{
	"dialog.ok": "OK",
	"dialog.cancel": "Annulla",
	"dialog.confirm": "Applica",
	"dialog.close": "Chiudi",
	"dialog.import": "Importa",
	"dialog.save": "Salva",
	"dialog.discard": "Ignora",
	"dialog.dontshowagain": "Non mostrare più",
	"data.cube": "Cubo",
	"data.group": "Gruppo",
	"data.texture": "Trama",
	"data.plugin": "Plugin",
	"data.preview": "Anteprima",
	"data.toolbar": "Barra Strumenti",
	"data.image": "Immagine",
	"keys.ctrl": "Ctrl",
	"keys.shift": "Maiusc",
	"keys.alt": "Alt",
	"keys.meta": "Cmd",
	"keys.delete": "Elimina",
	"keys.space": "Spazio",
	"keys.leftclick": "Clic sinistro",
	"keys.middleclick": "Clic centrale",
	"keys.rightclick": "Clic destro",
	"keys.tab": "Scheda",
	"keys.backspace": "Backspace",
	"keys.enter": "Invio",
	"keys.escape": "Esc",
	"keys.function": "F%0",
	"keys.numpad": "Tastierino numerico %0",
	"keys.caps": "Blocco maiuscole",
	"keys.menu": "Menu contestuale",
	"keys.left": "Sinistra",
	"keys.up": "Su",
	"keys.right": "Destra",
	"keys.down": "Giù",
	"keys.pageup": "Pagina su",
	"keys.pagedown": "Pagina giù",
	"keys.plus": "Più",
	"keys.comma": "Virgola",
	"keys.point": "Punto",
	"keys.minus": "Meno",
	"keys.cross": "Croce",
	"keys.end": "Fine",
	"keys.pos1": "Pos 1",
	"keys.printscreen": "Timbro",
	"keys.pause": "Pausa",
	"message.rotation_limit.title": "Limiti di Rotazione",
	"message.rotation_limit.message": "Le rotazioni sono limitate da Minecraft a un asse e incrementi di 22,5 gradi. La rotazione su un asse diverso cancellerà tutte le rotazioni sugli altri assi. Converti il ​​modello in \"Modello generico\" se stai modellando per altri scopi e hai bisogno di rotazioni libere.",
	"message.file_not_found.title": "File Non Trovato",
	"message.file_not_found.message": "Blockbench non ha potuto trovare il file richiesto. Assicurati che sia salvato localmente e non in un cloud.",
	"message.screenshot.title": "Schermata",
	"message.screenshot.clipboard": "Appunti",
	"message.screenshot.right_click": "Schermata - Tasto Destro per copiare",
	"message.invalid_file.title": "File Non valido",
	"message.invalid_file.message": "Impossibile aprire il modello: %0",
	"message.invalid_model.title": "File Modello Non valido",
	"message.invalid_model.message": "Questo file non contiene dati di modello validi.",
	"message.child_model_only.title": "Modello Vuoto",
	"message.child_model_only.message": "Questo file eredita %0 e non contiene un modello.",
	"message.unsaved_textures.title": "Trama Non Salvata",
	"message.unsaved_textures.message": "Questo modello utilizza trame non salvate. Assicurati di salvarle e inserirle nella nella cartella corretta della tua resource pack",
	"message.model_clipping.title": "Modello Troppo Grande",
	"message.model_clipping.message": "Il tuo modello contiene %0 cubi più grandi del limite di blocchi consentito da Minecraft. Questo modello non funzionerà in Minecraft.",
	"message.loose_texture.title": "Importa Trama",
	"message.loose_texture.message": "La trama importata non è contenuta in un pacchetto di risorse. Minecraft può caricare trame solo all'interno della cartella texture di un pacchetto di risorse caricato.",
	"message.loose_texture.change": "Cambia Percorso",
	"message.update_res.title": "Risoluzione Trama",
	"message.update_res.message": "Vuoi aggiornare la risoluzione del progetto alla risoluzione di questa texture? Clic su \"Annulla\" se la tua trama ha una risoluzione più alta del normale.",
	"message.update_res.update": "Aggiorna",
	"message.bedrock_overwrite_error.message": "Blockbench non riesce a combinare questo modello con un vecchio file",
	"message.bedrock_overwrite_error.backup_overwrite": "Crea Backup e Sovrascrivi",
	"message.bedrock_overwrite_error.overwrite": "Sovrascrivi",
	"message.close_warning.message": "Vuoi salvare il tuo modello?",
	"message.close_warning.web": "Il tuo lavoro corrente verra perso. Sei sicuro di volere uscire?",
	"message.default_textures.title": "Trame Predefinite",
	"message.default_textures.message": "Seleziona la cartella \"textures\" del resource pack predefinito",
	"message.default_textures.detail": "Estrai il resource pack predefinito dal jar di Minecraft oppure vai su google per scaricarlo. Poi trova la cartella \"textures\" ed aprila. Blockbench memorizzerà questa cartella e cercherà di prendere le texture da quella cartella se non può trovarle nel resource pack corrente.",
	"message.default_textures.select": "Seleziona la cartella \"textures\" predefinita",
	"message.image_editor.title": "Seleziona editor di immagini",
	"message.image_editor.file": "Seleziona File...",
	"message.image_editor.exe": "Seleziona un editor immagini",
	"message.display_skin.title": "Minecraft Skin",
	"message.display_skin.message": "Seleziona il file della Skin dal tuo computer oppure inserisci il nome del giocatore",
	"message.display_skin.upload": "Seleziona File",
	"message.display_skin.reset": "Resetta",
	"message.invalid_plugin": "File Plugin Invalido, Vedi Console",
	"message.load_plugin_app": "Vuoi permettere a questo plugin di effettuare modifiche al tuo PC? Carica plugin soltanto da persone fidate.",
	"message.load_plugin_web": "Vuoi caricare questo plugin? Carica plugin soltanto da persone fidate.",
	"message.preset_no_info": "Il preset non contiene informazioni per questo slot",
	"message.restart_to_update": "Per applicare le modifiche Riavvia Blockbench",
	"message.save_file": "Salvato come %0",
	"dialog.project.title": "Progetto",
	"dialog.project.name": "Nome File",
	"dialog.project.parent": "Modello Genitore",
	"dialog.project.geoname": "Nome Geometria Del Mob",
	"dialog.project.ao": "Occlusione Ambientale",
	"dialog.texture.title": "Trama",
	"dialog.texture.variable": "Variabile",
	"dialog.texture.namespace": "Spazio Nome",
	"dialog.texture.folder": "Cartella",
	"dialog.extrude.title": "Estrudi Immagine",
	"dialog.extrude.mode": "Modalità Scansione",
	"dialog.extrude.mode.areas": "Area",
	"dialog.extrude.mode.lines": "Linee",
	"dialog.extrude.mode.columns": "Colonne",
	"dialog.extrude.mode.pixels": "Pixel",
	"dialog.extrude.opacity": "Opacità Minima",
	"dialog.extrude.scan": "Scansiona e Importa",
	"dialog.display_preset.title": "Crea Preset",
	"dialog.display_preset.message": "Seleziona gli slot che vuoi salvare",
	"dialog.display_preset.create": "Crea",
	"dialog.select.title": "Seleziona",
	"dialog.select.group": "Nel Gruppo Selezionato",
	"dialog.select.name": "Nome Contiene",
	"dialog.select.random": "Casuale",
	"dialog.select.select": "Seleziona",
	"dialog.scale.title": "Scala Modello",
	"dialog.scale.axis": "Assi",
	"dialog.scale.clipping": "Ritaglio del modello: il modello è troppo grande per la tela",
	"dialog.scale.confirm": "Scala",
	"dialog.plugins.title": "Plugins",
	"dialog.plugins.installed": "Installati",
	"dialog.plugins.available": "Disponibili",
	"dialog.plugins.install": "Installa",
	"dialog.plugins.uninstall": "Disinstalla",
	"dialog.plugins.reload": "Ricarica",
	"dialog.plugins.none_installed": "Nessun plugin installato",
	"dialog.plugins.none_available": "Nessun plugin disponibile",
	"dialog.plugins.web_only": "Solo per l'app web",
	"dialog.plugins.app_only": "Solo per l'app desktop",
	"dialog.plugins.author": "di %0",
	"dialog.create_texture.folder": "Cartella",
	"dialog.create_texture.resolution": "Risoluzione",
	"dialog.input.title": "Input",
	"dialog.settings.settings": "Impostazioni",
	"dialog.settings.keybinds": "Combinazione Tasti",
	"dialog.settings.about": "Informazioni",
	"layout.color.back": "Indietro",
	"layout.color.back.desc": "Sfondi e campi di input",
	"layout.color.dark": "Scuro",
	"layout.color.dark.desc": "Sfondo tela",
	"layout.color.ui": "Interfaccia",
	"layout.color.ui.desc": "Colore interfaccia principale",
	"layout.color.bright_ui": "UI Luminoso",
	"layout.color.bright_ui.desc": "Menu contestuali e suggerimenti",
	"layout.color.button": "Tasto",
	"layout.color.button.desc": "Tasti e modalità",
	"layout.color.selected": "Selezionato",
	"layout.color.selected.desc": "Schede e oggetti selezionati",
	"layout.color.border": "Bordo",
	"layout.color.border.desc": "Bordo dei tasti e dei input",
	"layout.color.accent": "Accento",
	"layout.color.accent.desc": "Pollice scorrevole e altri dettagli",
	"layout.color.grid": "Griglia",
	"layout.color.grid.desc": "Griglia anteprima UV",
	"layout.color.text": "Testo",
	"layout.color.text.desc": "Testo Normale",
	"layout.color.light": "Chiaro",
	"layout.color.light.desc": "Testo evidenziato",
	"layout.color.accent_text": "Testo Accentato",
	"layout.color.accent_text.desc": "Testo su elementi chiari o accentati",
	"layout.font.main": "Carattere Principale:",
	"layout.font.headline": "Carattere del Titolo",
	"about.version": "Versione:",
	"settings.category.general": "Generale",
	"settings.category.preview": "Anteprima",
	"settings.category.grid": "Griglia",
	"settings.category.edit": "Modifica",
	"settings.category.snapping": "Snapping",
	"settings.category.defaults": "Predefiniti",
	"settings.category.dialogs": "Dialoghi",
	"settings.category.export": "Esporta",
	"settings.language": "Lingua",
	"settings.language.desc": "Lingua Utente",
	"settings.backup_interval": "Intervallo Backup",
	"settings.backup_interval.desc": "Intervallo del backup automatico in minuti",
	"settings.origin_size": "Marcatore Rotazione",
	"settings.origin_size.desc": "Dimensione del marcatore del punto di fulcro",
	"settings.control_size": "Dimensione Assi Controllo",
	"settings.control_size.desc": "Dimensioni di trasformazione",
	"settings.display_skin": "Minecraft Skin",
	"settings.display_skin.desc": "Skin utilizzata per il modello di riferimento del riproduttore",
	"settings.shading": "Ombreggiatura",
	"settings.shading.desc": "Attiva ombreggiatura nell'anteprima",
	"settings.base_grid": "Griglia Piccola",
	"settings.base_grid.desc": "Mostrare griglia picolla e assi",
	"settings.large_grid": "Griglia Grande",
	"settings.large_grid.desc": "Mostra griglia di dimensioni blocco 16x16",
	"settings.full_grid": "Griglia Grande Completa",
	"settings.full_grid.desc": "Mostra la griglia dei blocchi con precisione pixel",
	"settings.large_box": "Limite Dimensione Scatola",
	"settings.large_box.desc": "Mostra i limiti di dimensione",
	"settings.display_grid": "Griglia Modalità Vista",
	"settings.display_grid.desc": "Mostra griglia in modalità visualizzazione",
	"settings.undo_limit": "Limite Annullamento",
	"settings.undo_limit.desc": "Numero di passaggi che puoi annullare",
	"settings.local_move": "Sposta sugli Assi Relativi",
	"settings.local_move.desc": "Muovi elementi ruotati sul loro asse proprio, se possibile",
	"settings.canvas_unselect": "Deseleziona quando Clicco Sullo Sfondo",
	"settings.canvas_unselect.desc": "Deseleziona tutti gli elementi quando si clicca sullo sfondo dietro il modello o nella sequenza temporale",
	"settings.paint_side_restrict": "Restringi Pennello al Lato",
	"settings.paint_side_restrict.desc": "Restringi i pennelli a disegnare solo sul lato corrente",
	"settings.autouv": "UV Automatico",
	"settings.autouv.desc": "Attiva UV Automatico come predefinito",
	"settings.create_rename": "Renomina Nuovo Cubo",
	"settings.create_rename.desc": "Focalizzare il campo d'inserimento del nome quando si crea un nuovo elemento o un gruppo",
	"settings.edit_size": "Risoluzione Griglia",
	"settings.edit_size.desc": "Risoluzione della griglia alla quale si attaccano i cubi",
	"settings.shift_size": "Risoluzione Maiusc",
	"settings.shift_size.desc": "Risoluzione della griglia tenendo premuto Maiusc",
	"settings.ctrl_size": "Controllo Risoluzione",
	"settings.ctrl_size.desc": "Risoluzione della griglia tenendo premuto control",
	"settings.negative_size": "Dimensioni Negativa",
	"settings.negative_size.desc": "Permetti allo strumento di ridimensionamento di usare dimensioni negative",
	"settings.minifiedout": "Esporta Minimizzata",
	"settings.minifiedout.desc": "Registra JSON in una riga",
	"settings.export_groups": "Esporta Guppi Modelli Blocchi/Elementi Java",
	"settings.export_groups.desc": "Salva gruppi nei file dei modelli blocchi",
	"settings.credit": "Commento Credito",
	"settings.credit.desc": "Aggiungi un commento di credito ai files esportati",
	"settings.default_path": "Percorso Predefinito Trama Di Minecraft",
	"settings.default_path.desc": "Cartella nalla quale Blockbench carica le trame predefinite",
	"settings.image_editor": "Editor Immagini",
	"settings.image_editor.desc": "Editore immagini predefinito per modificare trame",
	"category.navigate": "Navigazione",
	"category.tools": "Strumenti",
	"category.file": "File",
	"category.blockbench": "Blockbench",
	"category.edit": "Modifica",
	"category.transform": "Trasforma",
	"category.view": "Vista",
	"category.display": "Impostazioni Schermo",
	"category.textures": "Trame",
	"category.misc": "Miscella",
	"keybind.preview_select": "Seleziona",
	"keybind.preview_rotate": "Ruota Vista",
	"keybind.preview_drag": "Trascina Vista",
	"keybind.confirm": "Applica",
	"keybind.cancel": "Annulla",
	"action.slider_inflate": "Gonfia",
	"action.slider_inflate.desc": "Gonfia cubi in tutte le direzioni non modificando l'UV",
	"action.slider_brush_size": "Dimensione",
	"action.slider_brush_size.desc": "Raggio del pennello in pixel",
	"action.slider_brush_opacity": "Opacità",
	"action.slider_brush_opacity.desc": "Percentuale dell'opacità del pennello",
	"action.slider_brush_softness": "Morbidezza",
	"action.slider_brush_softness.desc": "Percentuale della morbidezza del pennello",
	"action.uv_slider_pos_x": "Sposta Orizzontale",
	"action.uv_slider_pos_x.desc": "Sposta la selezione UV di tutti i cubi orizzontalmente",
	"action.uv_slider_pos_y": "Sposta Verticale",
	"action.uv_slider_pos_y.desc": "Sposta la selezione UV di tutti i cubi verticalmente",
	"action.uv_slider_size_x": "Scala Orizzontale",
	"action.uv_slider_size_x.desc": "Scala la selezione UV dei cubi selezionati orizzontalmente",
	"action.uv_slider_size_y": "Scala Verticale",
	"action.uv_slider_size_y.desc": "Scala la selezione UV dei cubi selezionati verticalmente",
	"action.vertex_snap_mode": "Modalità",
	"action.vertex_snap_mode.desc": "Seleziona se Vertex Snap sposta gli elementi nella posizione selezionata o li ridimensiona",
	"action.move_tool": "Muovi",
	"action.move_tool.desc": "Strumento per selezionare e muovere elementi",
	"action.resize_tool": "Ridimensiona",
	"action.resize_tool.desc": "Strumento per selezionare e ridimensionare elementi",
	"action.brush_tool": "Pennello",
	"action.brush_tool.desc": "Strumento per disegnare su texture bitmap, sulle superfici o sull'editore UV",
	"action.vertex_snap_tool": "Snap Vertici",
	"action.vertex_snap_tool.desc": "Muovi un cubo ad un'altro coniugando due vertici",
	"action.swap_tools": "Scambia Strumenti",
	"action.swap_tools.desc": "Alterna tra lo strumento di movimento e di ridimensionamento",
	"action.project_window": "Progetto...",
	"action.project_window.desc": "Apre la schermata del progetto dove puoi modificare i dati del tuo modello",
	"action.open_model": "Apri Modello",
	"action.open_model.desc": "Apri un modello dal tuo computer",
	"action.extrude_texture": "Trama Estrusa",
	"action.extrude_texture.desc": "Genera un modello sporgendo una texture",
	"action.export_blockmodel": "Esporta Modello Blocco",
	"action.export_blockmodel.desc": "Esporta un modello di blocco o oggetto Minecraft Java Edition",
	"action.export_optifine_part": "Esporta OptiFine JPM",
	"action.export_optifine_part.desc": "Esporta un modello entità Optifine parziale",
	"action.export_optifine_full": "Esporta OptiFine JEM",
	"action.export_optifine_full.desc": "Esporta un modello OptiFine entity completo",
	"action.export_obj": "Esporta Modello OBJ",
	"action.export_obj.desc": "Esporta un Wavefront OBJ per rendering o motori di gioco",
	"action.settings_window": "Impostazioni...",
	"action.settings_window.desc": "Apri il dialogo delle impostazioni Blockbench",
	"action.plugins_window": "Pluginis...",
	"action.plugins_window.desc": "Apri la schermata dei plugin",
	"action.reset_layout": "Ripristina Layout",
	"action.reset_layout.desc": "Ripristina il layout al predefinito di Blockbench",
	"action.load_plugin": "Carica Plugin dal File",
	"action.load_plugin.desc": "Carica un plugin importando il file sorgente",
	"action.reload_plugins": "Ricarica Plugins",
	"action.reload_plugins.desc": "Ricarica tutti i plugins in sviluppo",
	"action.undo": "Annulla",
	"action.undo.desc": "Annulla l'ultima modifica",
	"action.redo": "Ripristina",
	"action.redo.desc": "Ripristina l'ultimo annullamento",
	"action.copy": "Copia",
	"action.copy.desc": "Copia la selezione selezionata, la facca o le impostazioni di visualizzazione",
	"action.paste": "Incolla",
	"action.paste.desc": "Incolla la selezione selezionata, la facca o le impostazioni di visualizzazione",
	"action.cut": "Taglia",
	"action.cut.desc": "Taglia la selezione selezionata, la faccia o le impostazioni di visualizzazione",
	"action.add_cube": "Aggiungi Cubo",
	"action.add_cube.desc": "Aggiungi al nuovo cubo",
	"action.add_group": "Aggiungi Gruppo",
	"action.add_group.desc": "Aggiungi un nuovo gruppo oppure un osso",
	"action.outliner_toggle": "Attiva Altre Opzioni",
	"action.outliner_toggle.desc": "Attiva/disattiva tasti più opzioni nella lista degli elementi",
	"action.duplicate": "Duplica",
	"action.delete": "Elimina",
	"action.sort_outliner": "Ordina Lista Elementi",
	"action.sort_outliner.desc": "Ordina la lista degli elementi in ordine alfabetico",
	"action.select_window": "Seleziona...",
	"action.select_window.desc": "Cerca e seleziona cubi basandosi sulle loro proprietà",
	"action.invert_selection": "Inverti Selezione",
	"action.invert_selection.desc": "Inverti la selezione corrente dei cubi",
	"action.select_all": "Seleziona Tutto",
	"action.collapse_groups": "Collassa Gruppi",
	"action.collapse_groups.desc": "Collassa tutti i gruppi",
	"action.scale": "Scala...",
	"action.scale.desc": "Ridimensiona i cubi selezionati",
	"action.toggle_visibility": "Attiva Visibilità",
	"action.toggle_visibility.desc": "Attiva/disattiva la visibilità dei cubi selezionati",
	"action.toggle_export": "Attiva Esportazione",
	"action.toggle_export.desc": "Attiva/disattiva l'impostazione di esportazione degli elementi selezionati",
	"action.toggle_autouv": "Attiva UV Automatico",
	"action.toggle_autouv.desc": "Attiva/disattiva l'impostazione del UV automatico dei cubi selezionati",
	"action.toggle_shade": "Attiva Ombreggiatura",
	"action.toggle_shade.desc": "Attiva/disattiva l'ombreggiatura dei cubi selezionati",
	"action.rename": "Rinomina",
	"action.rename.desc": "Cambia il nome dei cubi selezionati",
	"action.add_display_preset": "Nuovo Preset",
	"action.add_display_preset.desc": "Aggiungi nuovo preset impostazioni schermo",
	"action.fullscreen": "Schermo Intero",
	"action.fullscreen.desc": "Alterna la modalità schermo intero",
	"action.zoom_in": "Ingrandisci",
	"action.zoom_in.desc": "Aumenta l'interfaccia grafica",
	"action.zoom_out": "Diminuisci",
	"action.zoom_out.desc": "Riduci zoom per ridurre dimensioni interfaccia",
	"action.zoom_reset": "Ripristina Zoom",
	"action.zoom_reset.desc": "Ripristina zoom al valore predefinito di 100%",
	"action.reset_interface": "Ripristina Interfaccia",
	"action.reset_interface.desc": "Ripristina le dimensioni e le posizioni dell'interfaccia grafica",
	"action.screenshot_model": "Schermata Modello",
	"action.screenshot_model.desc": "Scatta una schermata ritagliato del modello dall'angolo corrente",
	"action.screenshot_app": "Schermata Applicazione",
	"action.screenshot_app.desc": "Scatta una schermata dell'applicazione intera",
	"action.import_texture": "Importa Trama",
	"action.import_texture.desc": "Importa una o piu trame dal tuo sistema",
	"action.create_texture": "Crea Trama",
	"action.create_texture.desc": "Crea una trama vuota o da un modello",
	"action.save_textures": "Salva Trama",
	"action.save_textures.desc": "Salva tutte le trame non salvate",
	"action.animated_textures": "Riproduci Trama Animate",
	"action.animated_textures.desc": "Riproduci e metti in pausa l'anteprima della trama animata",
	"action.origin_to_geometry": "Perno Centrale",
	"action.origin_to_geometry.desc": "Metti l'origine al centro della geometria",
	"action.bone_reset_toggle": "Ripristina Osso",
	"action.bone_reset_toggle.desc": "Ferma l'osso dalla visualizzazione dei cubi dal modello genitore",
	"action.reload": "Ricarica Blockbench",
	"action.reload.desc": "Ricarica Blockbench. Questa azione annullera tutto il progresso non salvato.",
	"menu.file": "File",
	"menu.edit": "Modifica",
	"menu.transform": "Trasforma",
	"menu.display": "Schermo",
	"menu.view": "Vista",
	"menu.file.new": "Nuovo",
	"menu.file.recent": "Recenti",
	"menu.file.import": "Importa",
	"menu.file.export": "Esporta",
	"menu.transform.rotate": "Ruota",
	"menu.transform.flip": "Capovolgi",
	"menu.transform.center": "Centro",
	"menu.transform.properties": "Proprietà",
	"menu.display.preset": "Applica Preset",
	"menu.display.preset_all": "Applica Preset Ovunque",
	"menu.display.remove_preset": "Rimuovi Preset",
	"menu.view.zoom": "Zoom",
	"menu.view.background": "Sfondo",
	"menu.view.screenshot": "Schermata",
	"menu.cube.color": "Colore Cubo",
	"menu.cube.texture": "Texture",
	"menu.cube.texture.transparent": "Trasparente",
	"menu.cube.texture.blank": "Vuoto",
	"menu.group.sort": "Ordina",
	"menu.texture.face": "Applica a Facce",
	"menu.texture.file": "File",
	"menu.texture.refresh": "Aggiorna",
	"menu.texture.change": "Modifica File",
	"menu.texture.folder": "Apri In Cartella",
	"menu.texture.edit": "Modifica",
	"menu.texture.export": "Salva Come...",
	"menu.texture.save": "Salva",
	"menu.texture.properties": "Proprietà",
	"menu.preview.background": "Sfondo",
	"menu.preview.background.load": "Carica",
	"menu.preview.background.position": "Posizione",
	"menu.preview.background.lock": "Attacca Alla Videocamera",
	"menu.preview.screenshot": "Schermata",
	"menu.preview.perspective": "Prospettiva",
	"menu.preview.perspective.normal": "Normale",
	"menu.preview.quadview": "Vista Quadrupla",
	"menu.preview.stop_drag": "Ferma Posizionamento Sfondo",
	"menu.uv.mapping.rotation": "Rotazione",
	"menu.uv.texture": "Trama",
	"cube.color.light_blue": "Azzurro",
	"cube.color.yellow": "Giallo",
	"cube.color.orange": "Arancione",
	"cube.color.red": "Rosso",
	"cube.color.purple": "Viola",
	"cube.color.blue": "Blu",
	"cube.color.green": "Verde",
	"cube.color.lime": "Lime",
	"switches.visibility": "Visibilità",
	"switches.export": "Esporta",
	"switches.autouv": "UV Automatico",
	"panel.uv": "UV",
	"panel.display": "Schermo",
	"panel.textures": "Trama",
	"panel.outliner": "Schematizzatore",
	"uv_editor.title": "Editore UV",
	"uv_editor.all_faces": "Tutto",
	"uv_editor.no_faces": "Nessuno",
	"face.north": "Nord",
	"face.south": "Sud",
	"face.west": "Ovest",
	"face.east": "Est",
	"face.up": "Su",
	"face.down": "Giù",
	"direction.north": "Nord",
	"direction.south": "Sud",
	"direction.west": "Ovest",
	"direction.east": "Est",
	"direction.top": "Cima",
	"direction.bottom": "Fondo",
	"display.slot.third_right": "Terza Persona Destra",
	"display.slot.third_left": "Terza Persona Sinistra",
	"display.slot.first_right": "Prima Persona Destra",
	"display.slot.first_left": "Prima Persona Sinistra",
	"display.slot.head": "Testa",
	"display.slot.ground": "Terreno",
	"display.slot.frame": "Espositore",
	"display.slot.gui": "GUI",
	"display.rotation": "Rotazione",
	"display.translation": "Traslazione",
	"display.scale": "Scala",
	"display.slot": "Slot",
	"display.reference": "Modello Riferimento",
	"display.reference.player": "Riproduttore",
	"display.reference.zombie": "Zombie",
	"display.reference.armor_stand": "Supporto Armatura",
	"display.reference.baby_zombie": "Zombie Piccolo",
	"display.reference.armor_stand_small": "Supporto Armatura Piccolo",
	"display.reference.monitor": "Normale",
	"display.reference.bow": "Arco",
	"display.reference.block": "Blocco",
	"display.reference.frame": "Espositore",
	"display.reference.inventory_nine": "3x3",
	"display.reference.inventory_full": "Inventario",
	"display.reference.hud": "HUD",
	"display.preset.blank_name": "Pregasi inserire nome",
	"display.preset.item": "Elemento Predefinito",
	"display.preset.block": "Blocco Predefinito",
	"display.preset.handheld": "Arma Predefinita",
	"display.preset.rod": "Stecca Predefinita",
	"dialog.continue": "Continua",
	"message.square_textures": "Le trame devono essere quadrate",
	"message.unsaved_texture.title": "Trama Non Salvata",
	"message.unsaved_texture.message": "Tutte le modifiche non salvate verranno perse. Vuoi procedere?",
	"action.vertex_snap_mode.move": "Muovi",
	"action.vertex_snap_mode.scale": "Scala",
	"action.open_model_folder": "Apri Cartella Modello",
	"action.open_model_folder.desc": "Apri la cartella dove è contenuto il modello",
	"action.change_textures_folder": "Cambia Cartella Trame",
	"action.change_textures_folder.desc": "Modifica la cartella di salvataggio trame",
	"menu.texture.particle": "Usa per Particelle",
	"message.update_notification.title": "Impossibile installare l'aggiornamento",
	"message.update_notification.message": "È disponibile una nuova versione di Blockbench. Attiva gli aggiornamenti automatici nelle impostazioni per aggiornare!",
	"message.untextured": "Questa superfice non ha una texture",
	"dialog.toolbar_edit.title": "Personalizza Barra Strumenti",
	"keybindings.reset": "Resetta",
	"keybindings.clear": "Vuoto",
	"action.cube_counter": "Contatore Cubi",
	"action.uv_rotation": "Rotazione UV",
	"action.uv_rotation.desc": "Rotazione della faccia UV",
	"action.uv_grid": "Griglia UV",
	"action.uv_grid.desc": "Risoluzione della griglia alla quale si attacca il selettore UV",
	"action.uv_grid.auto": "Automatico",
	"action.uv_maximize": "Massimizza UV",
	"action.uv_maximize.desc": "Imposta l'UV di questa faccia alla texture completa",
	"action.uv_auto": "UV Automatico",
	"action.uv_auto.desc": "Imposta le dimensioni UV di questa faccia alle dimensioni reali della faccia",
	"action.uv_rel_auto": "UV Automatico Relativo",
	"action.uv_rel_auto.desc": "Imposta l'UV di questa faccia alla posizione e alla dimensione della faccia reale",
	"action.uv_mirror_x": "Specchia UV X",
	"action.uv_mirror_x.desc": "Specchia l'UV di questa faccia sull'asse delle X",
	"action.uv_mirror_y": "Specchia UV Y",
	"action.uv_mirror_y.desc": "Specchia l'UV di questa faccia sull'asse delle Y",
	"action.uv_transparent": "Faccia Trasparente",
	"action.uv_transparent.desc": "Rende la faccia corrente trasparente",
	"action.uv_reset": "Ripristina Faccia",
	"action.uv_reset.desc": "Ripristina la faccia corrente",
	"action.cullface": "Cullface",
	"action.cullface.desc": "Disabilita il rendering di questa faccia se il lato del modello selezionato è coperto",
	"action.auto_cullface": "Cullface Automatico",
	"action.auto_cullface.desc": "Imposta l'UV di questa faccia a se stesso",
	"action.face_tint": "Tinta",
	"action.face_tint.desc": "Abilita l'opzione della tinta per la faccia corrente",
	"menu.toolbar.edit": "Personalizza",
	"menu.toolbar.reset": "Ripristina",
	"uv_editor.rotated": "Ruotato",
	"uv_editor.auto_cull": "Cullface a Se Stesso",
	"uv_editor.copied": "Faccia Copiata",
	"uv_editor.pasted": "Faccia Incollata",
	"uv_editor.copied_x": "Volti %0 Copiate",
	"uv_editor.reset": "Ripristina Volto",
	"uv_editor.maximized": "Massimizzato",
	"uv_editor.autouv": "Dimensione Automatica",
	"uv_editor.mirrored": "Specchiato",
	"uv_editor.to_all": "Applicato a Tutte le Facce",
	"uv_editor.transparent": "Reso Trasparente",
	"uv_editor.cullface_on": "Cullface Abilitato",
	"uv_editor.cullface_off": "Cullface Disattivato",
	"uv_editor.tint_on": "Tinta Attivata",
	"uv_editor.tint_off": "Tinta Disattivata",
	"action.uv_apply_all": "Applica a Tutte le Facce",
	"action.uv_apply_all.desc": "Applica le impostazioni della faccia corrente a tuttle le facce",
	"message.image_editor_missing.title": "Editor Immagini Predefinito",
	"message.image_editor_missing.message": "Seleziona il file eseguibile del tuo editor di immagini.",
	"message.image_editor_missing.detail": "Blockbench non ha potuto trovare un editore immagini sul tuo computer. Seleziona il file esecutibile del tuo editore immagini preferito.",
	"action.update_autouv": "Aggiorna UV Automatico",
	"action.update_autouv.desc": "Aggionra la mappatura UV automatico dei cubi selezionati",
	"category.uv": "UV",
	"status_bar.saved": "Modello salvato",
	"status_bar.unsaved": "Ci sono modifiche non salvate",
	"action.move_up": "Sposta Sopra",
	"action.move_up.desc": "Sposta i cubi selezionati in su relativamente all'angolo della ",
	"action.move_down": "Sposta Sotto",
	"action.move_down.desc": "Muovi i cubi selezionati in giù relativamente all'angolo della videocamera",
	"action.move_left": "Sposta a Sinistra",
	"action.move_left.desc": "Sposta i cubi selezionati a sinistra relativamente all'angolo della ",
	"action.move_right": "Sposta a Destra",
	"action.move_right.desc": "Sposta i cubi selezionati a destra relativamente all'angolo della ",
	"action.move_forth": "Sposta Avanti",
	"action.move_forth.desc": "Sposta i cubi selezionati avanti relativamente all'angolo della ",
	"action.move_back": "Sposta Indietro",
	"action.move_back.desc": "Sposta i cubi selezionati indietro relativamente all'angolo della videocamera",
	"layout.color.wireframe": "Wireframe",
	"layout.color.wireframe.desc": "Linee del wireframe",
	"action.add_animation": "Aggiungi Animazione",
	"action.add_animation.desc": "Crea Animazione Vuota",
	"action.load_animation_file": "Importa Animazioni",
	"action.load_animation_file.desc": "Importa File Animazione",
	"action.play_animation": "Riproduci Animazione",
	"action.play_animation.desc": "Anteprima animazioni selezionate",
	"action.slider_keyframe_time": "Codice Temporale",
	"action.slider_keyframe_time.desc": "Modifica il Codice Temporale dei fotogrammi selezionati",
	"timeline.rotation": "Rotazione",
	"timeline.position": "Posizione",
	"timeline.scale": "Scala",
	"menu.keyframe.quaternion": "Quaternione",
	"panel.animations": "Animazioni",
	"panel.keyframe": "Fotogramma",
	"panel.keyframe.type": "Fotogramma (%0)",
	"generic.delete": "Elimina",
	"generic.rename": "Rinomina",
	"message.no_animation_selected": "Devi selezionare un'animazione per eseguire questa azione",
	"message.no_bone_selected": "Devi selezionare un osso per eseguire questa azione",
	"message.duplicate_groups.title": "Nome Osso Duplicato",
	"message.duplicate_groups.message": "Il nome di quest'osso esiste su ossa multipli. Qusto può causare problemi.",
	"action.delete_keyframes": "Elimina Fotogrammi",
	"action.delete_keyframes.desc": "Elimina tutti i fotogrammi selezionati",
	"menu.animation": "Animazione",
	"menu.animation.loop": "Ciclo Continuo",
	"menu.animation.override": "Sovrascrivi",
	"menu.animation.anim_time_update": "Aggiornamento Tempo Animazione",
	"message.display_skin_model.title": "Modello Skin",
	"message.display_skin_model.message": "Seleziona il tipo della tua skin",
	"message.display_skin_model.classic": "Classico",
	"message.display_skin_model.slim": "Sottile",
	"message.bone_material": "Modifica il materiale dell'osso",
	"action.slider_animation_length": "Lunghezza Animazione",
	"action.slider_animation_length.desc": "Modifica la lunghezza dell'animazione selezionata",
	"panel.variable_placeholders": "Variabili Segnaposto",
	"panel.variable_placeholders.info": "Elenca le variabili che vuoi vedere in anteprima facendo nome=valore",
	"status_bar.vertex_distance": "Distanza: %0",
	"dialog.create_gif.title": "Registra GIF",
	"dialog.create_gif.length": "Lunghezza",
	"dialog.create_gif.fps": "FPS",
	"dialog.create_gif.play": "Riproduci Animazione",
	"category.animation": "Animazione",
	"action.record_model_gif": "Registra GIF",
	"action.record_model_gif.desc": "Registra un'animazione GIF del modello dall'angolo corrente",
	"display.mirror": "Specchio",
	"data.separator": "Separatore",
	"menu.preview.background.set_position": "Imposta Posizione",
	"dialog.toolbar_edit.hidden": "Nascosto",
	"action.export_class_entity": "Esporta Entità Java",
	"action.export_class_entity.desc": "Esporta il modello entità come una classe Java",
	"settings.seethrough_outline": "Lineamenti Trasparenti",
	"settings.seethrough_outline.desc": "Mostra lineamenti attraverso oggetti",
	"mode.edit": "Modifica",
	"mode.paint": "Disegna",
	"mode.display": "Schermo",
	"mode.animate": "Animazione",
	"status_bar.recording_gif": "Registrazione",
	"status_bar.processing_gif": "Elaborazione",
	"settings.backup_retain": "Durata Conservazione Backup",
	"settings.backup_retain.desc": "Imposta per quanti giorni Blockbench mantiene i backup",
	"action.rotate_tool": "Ruota",
	"action.rotate_tool.desc": "Strumento per selezionare e ruotare elementi",
	"action.fill_tool": "Strumento di Riempimento",
	"action.fill_tool.desc": "Strumento di riempimento per riempire facce intere con un colore",
	"action.eraser": "Gomma",
	"action.eraser.desc": "Strumento gomma per cancellare colori di una trama",
	"action.color_picker": "Selezione Colori",
	"action.color_picker.desc": "Strumento per selezionare i colori dei pixel di una texture",
	"switches.mirror": "Specchia UV",
	"language_name": "Italiano",
	"message.plugin_reload": "%0 plugin locali ricaricati",
	"settings.brightness": "Luminosità",
	"settings.brightness.desc": "Luminosità dell'anteprima. Valore predefinito è 50.",
	"menu.preview.perspective.reset": "Ripristina Videocamera",
	"action.fill_mode": "Riempimento",
	"action.fill_mode.face": "Faccia",
	"action.fill_mode.color": "Colori",
	"action.toggle_mirror_uv": "Specchio UV",
	"action.toggle_mirror_uv.desc": "Alterna lo specchiamento UV sull'asse delle X dei cubi selezionati",
	"menu.texture.blank": "Applica a facce non strutturate",
	"dialog.scale.select_overflow": "Seleziona Cubi Traboccanti",
	"action.action_control": "Controllo Azioni",
	"action.action_control.desc": "Cerca ed esegui ogni azione disponibile",
	"keybindings.recording": "Registra Tasti",
	"keybindings.press": "Premi un tasto, una combinazione di tasti o clicca ovunque sullo schermo per registrare una combinzaione tasti.",
	"action.pivot_tool": "Strumento Origine",
	"action.pivot_tool.desc": "Strumento per modificare l'origine dei cubi e delle ossa",
	"action.slider_animation_speed": "Velocità Riproduzione",
	"action.slider_animation_speed.desc": "Percentuale della velocità di riproduzione",
	"action.previous_keyframe": "Fotogramma Precedente",
	"action.previous_keyframe.desc": "Salta al fotogramma precedente",
	"action.next_keyframe": "Avanti Fotogramma",
	"action.next_keyframe.desc": "Salta al prossimo fotogramma",
	"message.outdated_client.title": "Cliente obsoleto",
	"message.outdated_client.message": "Pregasi aggiornare Blockbench per effettuare questa azione.",
	"action.export_asset_archive": "Scarica Archivo",
	"action.export_asset_archive.desc": "Scarica un archivio con il modello e le texture",
	"action.upload_sketchfab": "Carica su Sketchfab",
	"message.sketchfab.name_or_token": "Pregasi inserire la chiave Sketchfab ed un nome",
	"dialog.sketchfab_uploader.title": "Carica Modello Sketchfab",
	"dialog.sketchfab_uploader.token": "Chiave API",
	"dialog.sketchfab_uploader.about_token": "Questa chiave è usata per connettere Blockbench al tuo profilo Sketchfab. Puoi trovarla su %0",
	"dialog.sketchfab_uploader.name": "Nome Modello",
	"dialog.sketchfab_uploader.description": "Descrizione",
	"dialog.sketchfab_uploader.tags": "Tag",
	"settings.sketchfab_token": "Chiave Sketchfab",
	"settings.sketchfab_token.desc": "Chiave di autorizzare Blockbench a caricare modelli sul tuo profilo Sketchfab",
	"panel.color": "Colore",
	"data.origin": "Origine",
	"message.sketchfab.success": "Modello caricato con successo",
	"message.sketchfab.error": "Caricamento Sktechfab fallito",
	"settings.outliner_colors": "Colori Outliner",
	"settings.outliner_colors.desc": "Mostrare colore cubi nella lista degli elemeti",
	"action.upload_sketchfab.desc": "Carica il tuo modello su Sketchfab",
	"action.element_colors": "Colori Cubi",
	"action.element_colors.desc": "Mostra colori cubi nella lista degli elementi",
	"texture.error.file": "File non trovato",
	"texture.error.parent": "File trama fornito da modello genitore",
	"message.recover_backup.title": "Recupera Modelli",
	"message.recover_backup.message": "Blockbench è stato chiuso senza salvare. Vuoi recuperare il modello?",
	"message.invalid_session.title": "Chiave Sessione Non Valida",
	"message.invalid_session.message": "La sessione alla quale stai cercando di connetterti è scaduta o la chiave è invalida",
	"dialog.create_texture.power": "Dimensione Potenza 2",
	"dialog.create_gif.turn": "Velocità Rotazione",
	"action.edit_session": "Sessione Modifiche...",
	"action.edit_session.desc": "Connettiti ad una sessione modifiche per collaborare con altri utenti",
	"action.reset_keyframe": "Ripristina Fotogramma",
	"action.reset_keyframe.desc": "Ripristina tutti i valori dei fotogrammi selezionati",
	"dialog.edit_session.title": "Sessione Modifiche",
	"edit_session.username": "Nome Utente",
	"edit_session.token": "Token",
	"edit_session.about": "Sessioni Modifiche possono essere usate per collaborare su modelli con altra gente attraverso internet. Crea una sessione, coppia la chiave e mandala ai tuoi amici. I tuoi amici possono usare la chiave per unirsi alla tua sessione.",
	"edit_session.join": "Connettiti alla Sessione",
	"edit_session.create": "Crea Sessione",
	"edit_session.quit": "Abbandona Sessione",
	"edit_session.joined": "Utente %0 si è unito alla sessione",
	"edit_session.left": "Utente %0 ha abbandonato la sessione",
	"edit_session.quit_session": "Abbandonato sessione corrente",
	"edit_session.status": "Stato",
	"edit_session.hosting": "Ospidando",
	"edit_session.connected": "Connesso ad una sessione",
	"dialog.sketchfab_uploader.private": "Privato (Pro)",
	"dialog.sketchfab_uploader.password": "Password (Pro)",
	"action.uv_select_all": "Seleziona Tutto",
	"action.uv_select_all.desc": "Seleziona tutti volti nel dialogo UV",
	"panel.chat": "Chat",
	"edit_session.welcome": "Benvenuto in questa sessione di %0",
	"dialog.yes": "Sì",
	"dialog.no": "No",
	"generic.remove": "Rimuovi",
	"generic.download": "Scarica",
	"generic.search": "Trova",
	"dates.today": "Oggi",
	"dates.yesterday": "Ieri",
	"dates.this_week": "Questa settimana",
	"dates.weeks_ago": "%0 settimane fa",
	"mode.start.new": "Nuovo",
	"mode.start.recent": "Recente",
	"format.free": "Modello Libero",
	"format.free.desc": "Modello senza restrizioni per Unity etc.",
	"format.java_block": "Blocco/Elemento Java",
	"format.java_block.desc": "Modello blocco per edizione Java. Dimensioni e rotazioni sono limitate.",
	"format.bedrock": "Modello Bedrock",
	"format.bedrock.desc": "Modello per edizione Bedrock",
	"format.bedrock_old": "Modello Bedrock Legacy",
	"format.bedrock_old.desc": "Modello entità Edizione Bedrock prima della versione 1.12",
	"format.modded_entity": "Entità Modificata",
	"format.modded_entity.desc": "Modelli entità per mod. Puo essere esportato come file delle classi java (.java)",
	"format.optifine_entity": "Entità OptiFine",
	"format.optifine_entity.desc": "Modello entità per OptiFine",
	"keys.mouse": "Tasto Mouse %0",
	"message.cleared_blank_faces.title": "Facce Vuote",
	"message.cleared_blank_faces.message": "Blockbench ha trovato %0 cubi senza una texture. Vuoi rimuovere questi elementi?",
	"message.wireframe.enabled": "Vista wireframe attivata",
	"message.wireframe.disabled": "Vista wireframe disattivata",
	"dialog.convert_project.title": "Converti Progetto",
	"dialog.create_texture.double_use": "Mantieni Occupazione Multi-trama",
	"dialog.model_stats.title": "Statistiche Modello",
	"dialog.model_stats.cubes": "Cubi",
	"dialog.model_stats.locators": "Localizzatori",
	"dialog.model_stats.groups": "Gruppi",
	"dialog.model_stats.vertices": "Vertici",
	"dialog.model_stats.faces": "Volti",
	"settings.username": "Nome Utente",
	"settings.username.desc": "Nome utente per sessioni modifiche",
	"settings.painting_grid": "Griglia Pittura",
	"settings.painting_grid.desc": "Mostra griglia su cubi con texture in modalità pittura",
	"action.convert_project": "Converti Progetto",
	"action.convert_project.desc": "Converte il progetto corrente in un altro formato",
	"action.close_project": "Chiudi Progetto",
	"action.close_project.desc": "Chiudi il progetto attualmente aperto",
	"action.export_bedrock": "Esporta Geometria Bedrock",
	"action.export_bedrock.desc": "Esporta il modello come un file geometria per edizione bedrock",
	"action.save_project": "Salva Progetto",
	"action.save_project.desc": "Salva il modello corrente come un file progetto",
	"action.save_project_as": "Salva Progetto Come",
	"action.save_project_as.desc": "Salva modelelo corrente come un file progetto in una posizione nuova",
	"action.export_over": "Sovrascrivi Modello",
	"action.export_over.desc": "Salva il modello, trame e animazioni sovrascrivendo i files",
	"action.add_locator": "Aggiungi localizzatore",
	"action.add_locator.desc": "Aggiungi un nuovo locator per controllare la posizione di particelle, guinzagli etc.",
	"action.uv_turn_mapping": "Ruota Mappatura",
	"action.uv_turn_mapping.desc": "Ruota la mappatura UV di 90 gradi",
	"action.remove_blank_faces": "Elimina Facce Vuote",
	"action.remove_blank_faces.desc": "Elimina tutte le facce della selezione senza trame",
	"web.download_app": "Scarica app",
	"uv_editor.turned": "Mappatura Ruotata",
	"display.reference.crossbow": "Balestra",
	"dialog.settings.search_results": "Risultati di Ricerca",
	"settings.animation_snap": "Collegamento Animazioni",
	"settings.animation_snap.desc": "Intervallo collegamento per i fotogrammi nella sequenza dell'animazione",
	"action.import_optifine_part": "Importa parte OptiFine",
	"action.import_optifine_part.desc": "Importa una parte di un modello per OptiFine",
	"data.locator": "Posizione",
	"mode.start.no_recents": "Nessun modello aperto recentemente",
	"panel.element": "Elemento",
	"panel.element.position": "Posizione",
	"panel.element.size": "Dimensione",
	"panel.element.origin": "Origine",
	"panel.element.rotation": "Rotazione",
	"message.canvas_limit_error.title": "Errore di Limite della Tela",
	"message.canvas_limit_error.message": "L'azione non può essere eseguita correttamente perché il formato limita la tela a 48 unità. Sposta il punto di articolazione per impedirlo.",
	"data.effect": "Effetto",
	"generic.name": "Nome",
	"settings.recent_projects": "Limite Modelli Recenti",
	"settings.recent_projects.desc": "Numero massimo di modelli recenti da ricordare",
	"settings.volume": "Volume",
	"settings.volume.desc": "Volume degli effetti sonori nelle animazioni",
	"action.clear_timeline": "Cancella Linea Temporale",
	"action.clear_timeline.desc": "Cancella tutte le ossa non selezionate dalla sequenza",
	"action.select_effect_animator": "Anima Effetti",
	"action.select_effect_animator.desc": "Apri la sequenza per aggiungere effetti sonori e particelle",
	"action.timeline_focus": "Filtra Canali",
	"action.timeline_focus.desc": "Seleziona i canali animazione da mostrare sulla sequenza",
	"timeline.particle": "Particella",
	"timeline.sound": "Suono",
	"timeline.effects": "Effetti",
	"data.format": "Formato",
	"format.optifine_part": "Parte OptiFine",
	"format.optifine_part.desc": "Parte JPM per modelli entity OptiFine",
	"action.reverse_keyframes": "Inverti Fotogrammi",
	"action.reverse_keyframes.desc": "Inverti l'ordine dei fotogrammi selezionati",
	"generic.help": "Aiuto",
	"message.removed_faces": "Rimossi %0 volti",
	"dialog.sketchfab_uploader.draft": "Bozza",
	"action.slider_pos": "Spostamento %0",
	"action.slider_pos.desc": "Sposta cubi sull'asse %0",
	"action.slider_size": "Dimensione %0",
	"action.slider_size.desc": "Ridimensiona elementi sull'asse %0",
	"action.slider_rotation": "Rotazione %0",
	"action.slider_rotation.desc": "Ruota i cubi sull'asse %0",
	"action.slider_origin": "Centro %0",
	"action.slider_origin.desc": "Sposta centro sull'asse %0",
	"action.rotate_cw": "Ruota %0 +90",
	"action.rotate_cw.desc": "Ruota i cubi selezionati di 90° sull'asse %0",
	"action.rotate_ccw": "Ruota %0 -90",
	"action.rotate_ccw.desc": "Ruota i cubi selezionati di -90° sull'asse %0",
	"action.flip": "Capovolgi %0",
	"action.flip.desc": "Capovolgi i cubi selezionati sull'asse %0",
	"action.center": "Centra %0",
	"action.center.desc": "Centra i cubi selezionati sull'asse %0",
	"action.bring_up_all_animations": "Minimizza Tutte le Animazioni",
	"panel.bone": "Osso",
	"data.color": "Colore",
	"generic.export": "Esporta",
	"generic.none": "Nessuno",
	"status_bar.recording": "Registrazione Temporizzazione",
	"message.add_to_palette": "Aggiunto a tavolozza",
	"message.size_modifiers": "Tieni premuto Ctrl o Maiusc per trasformare in incrementi più piccoli.",
	"message.timelapse_start": "Temporizzazione avviato",
	"message.timelapse_stop": "Temporizzazione interrotto",
	"message.import_palette.replace_palette": "Sostituisci vecchia tavolozza",
	"message.import_palette.threshold": "Unisci soglia",
	"dialog.timelapse.interval": "Intervallo (Secondi)",
	"dialog.timelapse.source": "Sorgente",
	"dialog.timelapse.source.interface": "Interfaccia",
	"dialog.timelapse.source.locked": "Angolo Bloccato",
	"dialog.timelapse.destination": "Cartella Destinataria",
	"layout.color.checkerboard": "Scacchiera",
	"layout.color.checkerboard.desc": "Sfondo tela ed editore UV",
	"layout.font.code": "Carattere Codici",
	"layout.css": "CSS Personalizzato",
	"settings.category.paint": "Colore",
	"settings.deactivate_size_limit": "Disattiva Limite Dimensioni",
	"settings.deactivate_size_limit.desc": "Disattiva il limite di dimensioni per formati di modelli specifici. ATTENZIONE: ciò può causare modelli non validi.",
	"settings.brush_opacity_modifier": "Modifica Opacità Pennello",
	"settings.brush_opacity_modifier.desc": "Modifica l'opacità del pennello quando viene utilizzato uno stilo",
	"settings.brush_size_modifier": "Modificata Dimensioni Pennello",
	"settings.brush_size_modifier.desc": "Modifica le dimensioni del pennello quando si utilizza uno stilo",
	"settings.brush_modifier.pressure": "Pressione",
	"settings.brush_modifier.tilt": "Inclina",
	"category.color": "Colore",
	"action.import_theme": "Importa Tema",
	"action.export_theme": "Esporta Tema",
	"action.export_theme.desc": "Crea un file tema basato sulle impostazioni correnti",
	"action.slider_color_h": "Tonalità",
	"action.slider_color_s": "Saturazione",
	"action.slider_color_v": "Valore",
	"action.add_to_palette": "Aggiungi a Tavolozza",
	"action.add_to_palette.desc": "Aggiungi il colore selezionato alla tavolozza",
	"action.import_palette": "Importa Tavolozza",
	"action.import_palette.desc": "Importa file tavolozza",
	"action.export_palette": "Esporta Tavolozza",
	"action.export_palette.desc": "Esporta la tavolozza come un file .GPL",
	"action.generate_palette": "Genera Tavolozza",
	"action.generate_palette.desc": "Genera una tavolozza da una texture",
	"action.sort_palette": "Ordina Tavolozza",
	"action.sort_palette.desc": "Ordina tutti i colori della tavolozza per colore e luminosità",
	"action.timelapse": "Temporizzazione...",
	"action.timelapse.desc": "Registra la Temporizzazione del tuo processo di modellazione",
	"action.add_keyframe": "Aggiungi Fotogramma",
	"action.add_keyframe.desc": "Aggiungi un fotogramma automaticamente. Premi Maiusc per forzare valori predefinti",
	"action.bring_up_all_animations.desc": "Porta tutti gli animatori modificati nella sequenza temporale",
	"timeline.timeline": "Istruzioni",
	"menu.palette.load.default": "Predefinito",
	"generic.import": "Importa",
	"settings.brush_modifier.none": "Nessuno",
	"action.export_entity": "Esporta Entità Bedrock",
	"action.export_entity.desc": "Aggiungi il modello corrente come un entity ad un file mobs.json",
	"settings.highlight_cubes": "Evidenzia Cubi",
	"settings.highlight_cubes.desc": "Evidenzia i cubi quando il mouse passa sopra o quando li selezioni",
	"action.add_marker": "Imposta Marcatore",
	"action.add_marker.desc": "Imposta un marcatore sulla sequenza",
	"timeline.pre_effect_script": "Script",
	"format.skin": "Skin",
	"format.skin.desc": "Modifica skin giocatori ed entity",
	"message.sketchfab.setup_guide": "Vuoi sapere come impostare i modelli su Sketchfab? Visita %0",
	"dialog.skin.title": "Crea Minecraft Skin",
	"dialog.skin.model": "Modello",
	"action.toggle_skin_layer": "Attiva/Disattiva Livello Skin",
	"action.toggle_skin_layer.desc": "Attiva/Disattiva livello del cappello e abbigliamento del modello della Skin",
	"action.gui_light": "Interfaccia Grafica Chiara",
	"action.gui_light.desc": "Scegli il modo in quale l'item è illuminato nell'inventario",
	"action.gui_light.side": "Luce Laterale",
	"action.gui_light.front": "Luce Frontale",
	"action.move_keyframe_back": "Sposta Fotogrammi Indietro",
	"action.move_keyframe_forth": "Sposta Fotogrammi Avanti",
	"menu.help": "Aiuto",
	"menu.help.discord": "Server Discord",
	"menu.help.report_issue": "Segnala un Problema",
	"menu.help.plugin_documentation": "Documentazione Plugin API",
	"menu.help.search_action": "Cerca ed Esegui Azione",
	"menu.help.donate": "Donazione",
	"menu.help.about": "Informazioni...",
	"menu.preview.background.clipboard": "Carica dagli Appunti",
	"dialog.ignore": "Ignora",
	"generic.unset": "Non settato",
	"message.invalid_builtin_parent.title": "Genitore Incorporato Invalido",
	"message.invalid_builtin_parent.message": "Il collegamento al modello principale non valido '% 0' è stato rimosso per esportare un modello valido.",
	"dialog.resize_texture.fill": "Riempire con",
	"dialog.resize_texture.fill.transparent": "Trasparente",
	"dialog.resize_texture.fill.color": "Colore",
	"dialog.resize_texture.fill.repeat": "Ripeti",
	"dialog.scale.element_pivot": "Origine dell'Elemento",
	"dialog.scale.selection_center": "Centro di Selezione",
	"dialog.create_gif.length_mode": "Modalità lunghezza",
	"dialog.create_gif.length_mode.seconds": "Secondi",
	"dialog.create_gif.length_mode.frames": "Montatura",
	"dialog.create_gif.length_mode.animation": "Lunghezza della'animazione",
	"dialog.create_gif.length_mode.turntable": "Velocità Rotazione",
	"dialog.save_angle.projection": "Proiezione",
	"dialog.save_angle.projection.perspective": "Prospettiva",
	"dialog.save_angle.projection.orthographic": "Ortografico",
	"dialog.sketchfab_uploader.animations": "Animazioni",
	"dialog.settings.theme": "Tema",
	"settings.category.interface": "Interfaccia",
	"settings.preview_checkerboard": "Anteprima Scacchiera",
	"settings.preview_checkerboard.desc": "Alterna lo sfondo a scacchiera dieto l'anteprima",
	"settings.uv_checkerboard": "Scacchiera Editore UV",
	"settings.uv_checkerboard.desc": "Alterna lo sfondo a scacchiera dietro l'editore UV",
	"category.paint": "Dipingi",
	"action.fill_mode.color_connected": "Colori Connessi",
	"action.draw_shape_type": "Tipo di forma",
	"action.draw_shape_type.rectangle": "Rettangolo",
	"action.draw_shape_type.rectangle_h": "Rettangolo (Vuoto)",
	"action.draw_shape_type.ellipse": "Ellisse",
	"action.draw_shape_type.ellipse_h": "Ellisse (Vuota)",
	"action.draw_shape_type.line": "Linea",
	"action.mirror_painting": "Pittura Specchiata",
	"action.mirror_painting.description": "Specchia il tratto del pennello sull'altro lato del modello",
	"action.lock_alpha": "Blocca Canale Alfa",
	"action.lock_alpha.description": "Blocca la trasparenza di tutti i pixel",
	"action.draw_shape_tool": "Disegna una forma",
	"action.draw_shape_tool.desc": "Strumento per disegnare figure semplici sulle texture",
	"action.export_gltf": "Esporta Modello glTF",
	"action.export_gltf.desc": "Esporta il modello e le animzioni come un file glTF per usarlo in altre applicazioni 3D",
	"action.transform_space": "Spazio Trasformazione",
	"action.transform_space.desc": "Spazio trasformazione predefinito per tutti gli elementi e ossa",
	"action.transform_space.global": "Globale",
	"action.transform_space.local": "Locale",
	"action.toggle_camera_projection": "Alterna Proiezione Videocamera",
	"action.toggle_camera_projection.desc": "Alterna la proezione della videocamera tra prospettiva e ortografica",
	"action.load_camera_angle": "Angolo Videocamera: %0",
	"action.load_camera_angle.desc": "Carica l'angolo videocamera '%0'",
	"action.slider_face_tint": "Indice Tinta",
	"action.slider_face_tint.desc": "Imposta l'indice tinta della faccia corrente. -1 vuol dire non impostato.",
	"menu.help.quickstart": "Procedura Guidata D'inizio",
	"menu.help.developer": "Sviluppatore",
	"menu.help.developer.dev_tools": "Apri Strumenti Sviluppo",
	"menu.help.developer.reset_storage": "Ripristina Impostazioni",
	"menu.help.developer.reset_storage.confirm": "Sicuro di voler ripristinare Blockbench alle impostazioni di fabbrica? Questo eliminera tutte le impostazioni, tutti i tasti personalizzati e plugin installati.",
	"menu.help.developer.cache_reload": "Ricarica Cache",
	"menu.preview.orthographic": "Ortografico",
	"menu.preview.save_angle": "Salva Angolo...",
	"menu.preview.angle": "Angoli",
	"menu.preview.angle.initial": "Angolo Iniziale",
	"menu.preview.maximize": "Aumentare al Massimo",
	"uv_editor.copy_selection": "Copia Selezione",
	"uv_editor.paste_selection": "Incolla Selezione",
	"uv_editor.copy_paste_tool.place": "Piazza",
	"uv_editor.copy_paste_tool.mirror_x": "Specchio Asse X",
	"uv_editor.copy_paste_tool.mirror_y": "Specchio Asse Y",
	"uv_editor.copy_paste_tool.rotate": "Ruota 90 Gradi",
	"dialog.project.modded_entity_version": "Versione Esporto",
	"dialog.save_angle.position": "Posizione Videocamera",
	"dialog.save_angle.target": "Punto Focale",
	"dialog.skin.pose": "Posa",
	"layout.color.frame": "Cornice Finestra",
	"layout.color.frame.desc": "Bordi e panello titolare della finestra",
	"settings.large_grid_size": "Dimensioni Reticolato Blocco",
	"settings.large_grid_size.desc": "Dimensioni del reticolato dei blocchi",
	"action.load_plugin_from_url": "Carica Plugin da URL",
	"action.load_plugin_from_url.desc": "Carica un plugin da un server specificando un URL",
	"action.cube_counter.desc": "Mostra il numero corrente dei cubi e altri dati",
	"action.unlock_everything": "Sblocca Tutti",
	"action.unlock_everything.desc": "Sblocca tutti i gruppi ed elementi nella lista degli elementi",
	"action.load_palette": "Carica Tavolozza",
	"action.load_palette.desc": "Carica una delle tavolozze integrate",
	"action.toggle_locked": "Alterna Blocco",
	"action.toggle_locked.desc": "Alterna lo stato di blocco degli elementi selezionati",
	"action.apply_display_preset": "Applica Preset",
	"action.apply_display_preset.desc": "Applica un preset impostazioni schermo predefinito oppure un preset personalizzato",
	"action.apply_display_preset.here": "Applica a Questo Slot",
	"action.apply_display_preset.everywhere": "Applica a Tutti gli Slot",
	"action.resolve_keyframe_expressions": "Risolvi Fotogrammi",
	"action.resolve_keyframe_expressions.desc": "Risolvi le espressioni matematiche dei fotogrammi selezionati",
	"action.fold_all_animations": "Chiudi Animazioni",
	"menu.palette.load.empty": "Vuoto",
	"switches.lock": "Blocca",
	"settings.render_sides": "Lati Esecuzioni",
	"settings.render_sides.desc": "Seleziona il lato di una faccia che viene mostrato",
	"settings.render_sides.auto": "Automatico",
	"settings.render_sides.front": "Fuori",
	"settings.render_sides.double": "Dentro e Fuori",
	"generic.enable": "Attiva",
	"generic.disable": "Disattiva",
	"generic.redacted": "Redatto",
	"dialog.select_texture.import_all": "Importa tutto",
	"dialog.skin.layer_template": "Livello Trama",
	"about.version.up_to_date": "Aggiornata",
	"about.version.update_available": "Versione %0 disponibile",
	"settings.category.application": "Applicazione",
	"settings.streamer_mode": "Modalità Streamer",
	"settings.streamer_mode.desc": "Nascondi informazioni sensibili come i modelli recenti",
	"settings.automatic_updates": "Aggiornamenti Automatici",
	"settings.automatic_updates.desc": "Scarica automaticamente nuove versioni e mantieni Blockbench aggiornato",
	"action.rotation_space": "Spazio Rotazione",
	"action.focus_on_selection": "Vista Centrale sulla Selezione",
	"action.focus_on_selection.desc": "Allinea la telecamera in modo che sia rivolta verso il centro della selezione corrente",
	"action.jump_to_timeline_start": "Salta all'Inizio dell'Animazione",
	"action.jump_to_timeline_end": "Salta alla Fine dell'Animazione",
	"menu.help.updating": "Aggiornamento (%0%)",
	"menu.help.update_failed": "Aggiornamento Fallito",
	"menu.animation.loop.once": "Riproduci una volta",
	"menu.animation.loop.hold": "Mantieni l'ultimo fotogramma",
	"menu.animation.loop.loop": "Ciclo Continuo",
	"interface.streamer_mode_on": "Modalità Streamer attivata",
	"generic.reset": "Resetta",
	"generic.restore": "Ripristina",
	"keys.mousewheel": "Rotella Mouse",
	"message.delete_animation.title": "Elimina Animazione",
	"message.delete_animation.message": "L'animazione è stata rimossa da Blockbench. Vuoi eliminare l'animazione dal file in cui è stata salvata?",
	"message.no_animation_to_import": "Nessuna animazione da importare",
	"dialog.material_instances.title": "Material Instances",
	"dialog.animation_import.title": "Seleziona animazioni da importare",
	"dialog.create_texture.padding": "Padding",
	"settings.fov": "FOV",
	"settings.fov.desc": "Campo visivo della telecamera. Il valore predefinito è 45",
	"settings.minify_bbmodel": "File di progetto minimizzati",
	"settings.minify_bbmodel.desc": "Scrivi file .bbmodel minimizzati in una riga",
	"action.edit_material_instances": "Modifica istanze di materiale",
	"action.edit_material_instances.desc": "Modifica nomi di istanze di materiale per geometrie di blocchi di roccia",
	"action.save_all_animations": "Salva tutte le animazioni",
	"action.save_all_animations.desc": "Salva tutte le animazioni attualmente caricate",
	"action.keyframe_interpolation": "Interpolazione",
	"action.keyframe_interpolation.desc": "Seleziona la modalità di interpolazione dei fotogrammi chiave",
	"action.keyframe_interpolation.linear": "Lineare",
	"action.keyframe_interpolation.catmullrom": "Liscio",
	"action.timeline_focus.hide_empty": "Nascondi canali vuoti",
	"menu.file.preferences": "Preferenze",
	"menu.animation.blend_weight": "Peso Miscela",
	"menu.animation.save": "Salva",
	"menu.animation.properties": "Proprietà...",
	"menu.animation.file": "File",
	"menu.animation.snapping": "Snapping",
	"menu.animation.open_location": "Apri posizione file",
	"panel.keyframe.add_data_point": "Aggiungi punto dati fotogramma chiave",
	"panel.keyframe.remove_data_point": "Rimuovi punto dati",
	"panel.keyframe.pre": "Pre",
	"panel.keyframe.post": "Post",
	"generic.all": "Tutto",
	"message.small_face_dimensions.title": "Dimensioni facciali incompatibili",
	"message.small_face_dimensions.message": "La selezione contiene facce più piccole di 1 unità in una direzione. Il sistema di mappatura UV Box considera tutte le facce al di sotto di tale soglia come larghe 0 pixel. La texture su quelle facce potrebbe quindi non funzionare correttamente.",
	"message.small_face_dimensions.face_uv": "Il formato corrente supporta mappe UV per faccia che possono gestire piccole dimensioni della faccia. Fai clic con il pulsante destro del mouse sui cubi interessati e modifica \"UV Mode\" in \"Per-face UV\".",
	"dialog.plugins.outdated_client": "Richiede una nuova versione di Blockbench",
	"dialog.plugins.outdated_plugin": "Il plugin è obsoleto e non funziona con questa versione di Blockbench",
	"settings.motion_trails": "Tracce di movimento",
	"settings.motion_trails.desc": "Mostra tracce di movimento nell'editor di animazione",
	"settings.antialiasing": "Anti-aliasing",
	"settings.antialiasing.desc": "Attiva l'anti-aliasing nell'anteprima. Riavvia Blockbench per applicare le modifiche",
	"action.timeline_frame_back": "Salta 1 fotogramma indietro",
	"action.timeline_frame_forth": "Salta 1 fotogramma avanti",
	"panel.bone.ik": "Cinematica inversa (sperimentale)",
	"settings.particle_tick_rate": "Frequenza Tick Particelle",
	"settings.particle_tick_rate.desc": "Frequenza tick per effetti particelle in tick al secondo. Il valore predefinito è 30",
	"action.lock_motion_trail": "Blocca traccia movimento",
	"action.lock_motion_trail.desc": "Blocca la traccia movimento al gruppo attualmente selezionato",
	"menu.animation_file.unload": "Scarica File",
	"data.null_object": "Oggetto nullo",
	"status_bar.toggle_sidebar": "Attiva/disattiva barra laterale",
	"message.load_plugin_failed.title": "Impossibile caricare il plugin",
	"message.load_plugin_failed.message": "Assicurati che il nome file di base del plugin corrisponda all'ID plugin `%0`, come specificato in Plugin.register().",
	"dialog.project.uv_mode": "Modalità UV",
	"dialog.project.uv_mode.box_uv": "Box UV",
	"dialog.project.uv_mode.face_uv": "UV per faccia",
	"dialog.project.texture_size": "Dimensione trama",
	"dialog.animation_export.title": "Seleziona animazioni da esportare",
	"dialog.create_texture.rearrange_uv": "Riorganizza UV",
	"layout.color.subtle_text": "Testo Sottile",
	"layout.color.subtle_text.desc": "Colore testo secondario con meno contrasto",
	"settings.interface_scale": "Scala Interfaccia",
	"settings.interface_scale.desc": "Scala dell'intera interfaccia Blockbench",
	"settings.background_rendering": "Rendering sfondo",
	"settings.background_rendering.desc": "Aggiorna l'anteprima mentre la finestra non è a fuoco",
	"settings.ctrl_shift_size": "Risoluzione Ctrl + Maiusc",
	"settings.ctrl_shift_size.desc": "Risoluzione della griglia tenendo premuti Ctrl e Maiusc",
	"settings.hardware_acceleration": "Accellerazione Hardware",
	"settings.hardware_acceleration.desc": "Esternalizza le attività di rendering alla scheda grafica",
	"action.explode_skin_model": "Esplodi modello skin",
	"action.explode_skin_model.desc": "Attiva/disattiva una vista esplosione che consente di modificare le facce coperte",
	"action.export_minecraft_skin": "Esporta Skin di Minecraft",
	"action.export_minecraft_skin.desc": "Esporta la skin di Minecraft come texture PNG",
	"action.add_null_object": "Aggiungi oggetto nullo",
	"action.add_null_object.desc": "Aggiungi un nuovo oggetto nullo",
	"action.animated_texture_frame": "Trama fotogramma animata",
	"action.animated_texture_frame.desc": "Imposta il fotogramma corrente della trama animata",
	"action.export_animation_file": "Esporta Animazioni...",
	"action.export_animation_file.desc": "Esporta una selezione di animazioni in un nuovo file",
	"action.timeline_graph_editor": "Attiva/disattiva editor grafico",
	"action.timeline_graph_editor.desc": "Attiva/disattiva la timeline tra la vista editor grafico e la vista fotogramma",
	"menu.file.recent.clear": "Cancella Files Recenti",
	"switches.shade": "Ombra",
	"generic.share": "Condividi",
	"dates.minute": "%0 Minuto",
	"dates.minutes": "%0 Minuti",
	"dates.hour": "%0 Ora",
	"dates.hours": "%0 Ore",
	"dates.day": "%0 Giorno",
	"dates.days": "%0 Giorni",
	"dates.week": "%0 Settimana",
	"dates.weeks": "%0 Settimane",
	"dates.year": "%0 Anno",
	"dates.years": "%0 Anni",
	"message.installed_plugin": "Installato correttamente il plugin %0",
	"message.installed_plugin_fail": "Impossibile installare il plugin %0",
	"dialog.share_model.title": "Condividi Modello",
	"dialog.share_model.expire_time": "Scadenza Tempo",
	"dialog.share_model.failed": "Caricamento del modello fallito",
	"action.import_java_block_model": "Aggiungi modello Java Blocco/Elemento",
	"action.import_java_block_model.desc": "Aggiungi un modello Java Blocco/Elemento di Minecraft da un file json al modello corrente",
	"action.share_model": "Condividi...",
	"action.share_model.desc": "Genera un collegamento breve per condividere il tuo modello",
	"action.import_project": "Importa progetto",
	"action.import_project.desc": "Importa un altro progetto da un file .bbmodel nel progetto corrente",
	"dialog.toolbar_edit.hidden_tools": "Alcuni strumenti potrebbero essere nascosti perché non sono disponibili nella modalità, nel formato o nella situazione correnti.",
	"settings.camera_near_plane": "Telecamera Vicino al Piano",
	"settings.camera_near_plane.desc": "La distanza minima dalla telecamera in cui vengono renderizzati gli oggetti. Valori più alti riducono lo Z-fighting. Il valore predefinito è 1.",
	"mode.start.keymap_preference.desc": "Se sei nuovo su Blockbench e provieni da un altro programma 3D, puoi selezionare una mappa dei tasti per semplificare la transizione. Puoi modificare la mappa dei tasti o le singole combinazioni di tasti in seguito nelle impostazioni.",
	"message.load_keymap": "Sicuro di voler caricare questa mappa dei tasti? Questo sovrascriverà le tue combinazioni di tasti correnti.",
	"message.keymap_loaded": "Mappa dei tasti caricata",
	"dialog.convert_project.current_format": "Formato corrente",
	"dialog.create_texture.rearrange_uv.desc": "Crea una nuova disposizione UV per dare a ogni faccia il suo posto sulla texture",
	"dialog.create_texture.power.desc": "Blocca la dimensione automatica della texture a una potenza di 2, come 64 o 128. Questo è richiesto da alcuni renderer",
	"dialog.create_texture.double_use.desc": "Se due elementi hanno già assegnato lo stesso spazio UV, mantienilo così nella nuova mappa",
	"dialog.create_texture.padding.desc": "Aggiungi una piccola spaziatura tra le singole parti del modello",
	"dialog.create_texture.resolution.desc": "Altezza e larghezza della trama",
	"dialog.create_gif.color": "Colore di sfondo",
	"dialog.save_angle.zoom": "Zoom",
	"dialog.skin.variant": "Variante",
	"dialog.flip_animation.info": "Le ossa opposte sono identificate dalle parole chiave 'sinistra' e 'destra' all'interno del loro nome.",
	"dialog.export_private_settings.title": "Impostazioni private",
	"dialog.export_private_settings.message": "Il tuo file contiene le seguenti informazioni private: **%0**. Ometti questi valori se intendi condividere il file con qualcun altro.",
	"dialog.export_private_settings.keep": "Mantieni",
	"settings.timecode_frame_number": "Visualizza i codici temporali come numeri di fotogramma",
	"settings.timecode_frame_number.desc": "Visualizza codice temporale frazionari in timeline come numero di fotogramma anziché centisecondo",
	"settings.animation_sample_rate": "Frequenza Campionamento Animazione",
	"settings.animation_sample_rate.desc": "Frequenza di campionamento al secondo per curve che il rispettivo formato non supporta in modo nativo",
	"keybind.preview_zoom": "Zoom Vista",
	"action.gradient_tool": "Strumento Inclinazione",
	"action.gradient_tool.desc": "Crea un gradiente di colore sulla tua trama",
	"action.import_settings": "Importa Impostazioni",
	"action.import_settings.desc": "Importa file .bbsettings",
	"action.export_settings": "Esporta Impostazioni",
	"action.export_settings.desc": "Esporta le impostazioni di Blockbench come file .bbsettings",
	"action.load_keymap": "Carica Mappa Tasti",
	"action.load_keymap.default": "Predefinito (Trackpad/Mouse)",
	"action.load_keymap.mouse": "Predefinito (Mouse)",
	"action.load_keymap.default.desc": "Tasti di scelta rapida predefiniti di Blockbench, con controlli di navigazione della finestra ottimizzati per l'uso sui trackpad dei laptop",
	"action.load_keymap.mouse.desc": "Tasti di scelta rapida predefiniti di Blockbench, con navigazione della finestra associata al tasto centrale del mouse",
	"action.load_keymap.blender.desc": "Keymap per utenti che hanno familiarità con i controlli di Blender",
	"action.load_keymap.cinema4d.desc": "Keymap per utenti che hanno familiarità con i controlli di Cinema 4D",
	"action.load_keymap.maya.desc": "Keymap per utenti che hanno familiarità con i controlli di Autodesk Maya",
	"action.import_keymap": "Importa Keymap",
	"action.import_keymap.desc": "Importa le combinazioni di tasti in un file .bbkeymap",
	"action.export_keymap": "Esporta Keymap",
	"action.export_keymap.desc": "Esporta le combinazioni di tasti correnti in un file .bbkeymap",
	"action.edit_history": "Cronologia Modifiche...",
	"action.edit_history.desc": "Visualizza la cronologia delle modifiche e annulla o ripeti i passaggi",
	"action.group_elements": "Raggruppa Elementi",
	"action.group_elements.desc": "Avvolgi gli elementi selezionati in un nuovo gruppo",
	"action.unfold_groups": "Dispiega Gruppi",
	"action.unfold_groups.desc": "Dispiega tutti i gruppi nell'outline",
	"action.edit_bedrock_binding": "Modifica Associazione...",
	"action.edit_bedrock_binding.desc": "Cambia a quale osso è associata la geometria",
	"action.pick_screen_color": "Seleziona Colore Schermo",
	"action.pick_screen_color.desc": "Seleziona un colore da qualche parte sullo schermo",
	"action.view_mode": "Modalità Vista",
	"action.view_mode.desc": "Cambia la modalità di visualizzazione del modello",
	"action.view_mode.textured": "Struttura",
	"action.view_mode.solid": "Solido",
	"action.view_mode.wireframe": "Wireframe",
	"action.toggle_sidebars": "Attiva/disattiva barre laterali",
	"action.toggle_sidebars.desc": "Attiva o disattiva le barre laterali",
	"action.set_animation_end": "Imposta fine animazione",
	"action.set_animation_end.desc": "Imposta la fine dell'animazione selezionata sul tempo corrente della linea temporale",
	"action.flip_animation": "Capovolgi Animazione",
	"action.flip_animation.desc": "Capovolge parte di un'animazione copiando i fotogrammi chiave selezionati sull'altro lato del modello",
	"action.graph_editor_zero_line": "Includi Zero Line",
	"action.graph_editor_zero_line.desc": "Se l'editor grafico include sempre la linea zero nella vista",
	"menu.texture.render_mode": "Modalità Render",
	"menu.texture.render_mode.emissive": "Emissivo",
	"menu.texture.render_mode.layered": "Livelli",
	"menu.preview.angle.edit": "Modifica Angolo...",
	"menu.animation.start_delay": "Ritardo Avvio",
	"menu.animation.loop_delay": "Ritardo Ripetizione",
	"menu.animation.flip_keyframes": "Capovolgi Fotogrammi",
	"menu.mobile_keyboard.disable_all": "Disabilita tutto",
	"panel.keyframe.toggle_uniform_scale": "Attiva/Disattiva Scala Uniforme",
	"camera_angle.common_isometric_right": "Isometrica Destra (2:1)",
	"camera_angle.common_isometric_left": "Isometrica Sinistra (2:1)",
	"camera_angle.true_isometric_right": "Isometrica Destra Vera (30°)",
	"camera_angle.true_isometric_left": "Isometrica Sinistra Vera (30°)",
	"menu.help.wiki": "Wiki Blockbench",
	"settings.update_to_prereleases": "Aggiornamento Pre-releases",
	"settings.update_to_prereleases.desc": "Aggiorna automaticamente alle versioni beta di Blockbench per testare le nuove funzionalità. Le versioni pre-release possono essere instabili, non abilitare questa opzione se fai affidamento su Blockbench per lavoro o altri progetti importanti.",
	"data.separator.spacer": "Distanziatore",
	"data.separator.linebreak": "Interruzione Riga",
	"data.setting": "Impostazione",
	"generic.select_all": "Seleziona Tutto",
	"generic.select_none": "Non selezionare nessuno",
	"projects.new_tab": "Nuova Scheda",
	"projects.close_tab": "Chiudi Scheda",
	"message.invalid_format.title": "Formato non valido",
	"message.invalid_format.message": "Questo modello è stato creato nel formato '%0', che non è disponibile nella tua installazione di Blockbench. Probabilmente hai bisogno di un plugin specifico per aprirlo correttamente.",
	"message.invalid_link": "Link al modello non valido o scaduto",
	"message.default_textures.current": "Percorso corrente",
	"message.update_after_restart": "L'aggiornamento verrà installato dopo il prossimo riavvio",
	"message.copy_paste_tool_viewport": "Questo strumento può essere utilizzato solo nell'editor 2D",
	"dialog.project.shadow_size": "Dimensione Ombra",
	"dialog.find_replace.target": "Target",
	"dialog.find_replace.target.element_names": "Nomi Elemento",
	"dialog.find_replace.target.group_names": "Nomi Gruppo",
	"dialog.find_replace.target.animation_names": "Nomi Animazione",
	"dialog.find_replace.target.keyframe_values": "Valori Fotogramma",
	"dialog.find_replace.find": "Trova",
	"dialog.find_replace.replace": "Sostituisci",
	"dialog.find_replace.regex": "Espressione Regolare",
	"dialog.add_primitive.shape": "Forma",
	"dialog.add_primitive.shape.circle": "Cerchio",
	"dialog.add_primitive.shape.tube": "Tubo",
	"dialog.add_primitive.shape.cone": "Cono",
	"dialog.add_primitive.shape.cylinder": "Cilindro",
	"dialog.add_primitive.shape.sphere": "Sfera",
	"dialog.add_primitive.shape.torus": "Toro",
	"dialog.add_primitive.shape.cube": "Cuboide",
	"dialog.add_primitive.shape.pyramid": "Piramide",
	"dialog.add_primitive.diameter": "Diametro",
	"dialog.add_primitive.height": "Altezza",
	"dialog.add_primitive.sides": "Lati",
	"dialog.add_primitive.minor_diameter": "Spessore",
	"dialog.add_primitive.minor_sides": "Lati minori",
	"dialog.create_texture.combine_polys": "Combina isole",
	"dialog.create_texture.combine_polys.desc": "Combina facce in isole UV connesse",
	"dialog.model_stats.meshes": "Mesh",
	"dialog.export_private_settings.omit": "Escludi",
	"layout.select": "Seleziona",
	"layout.options": "Opzioni",
	"layout.color": "Schema Colori",
	"layout.documentation": "Documentazione",
	"layout.color.bright_ui_text": "Testo interfaccia utente luminoso",
	"layout.color.bright_ui_text.desc": "Testo su sfondi luminosi",
	"layout.name": "Nome",
	"layout.author": "Autore",
	"settings.dialog.desc": "Mostra la finestra di dialogo \"%0\"",
	"settings.export_empty_groups": "Esporta Gruppi Vuoti",
	"settings.export_empty_groups.desc": "Includi gruppi senza contenuto nei file esportati",
	"category.separators": "Separatori",
	"keybind.preview_area_select": "Selezione Area",
	"action.color_erase_mode": "Modalità Cancellazione",
	"action.color_erase_mode.desc": "Con la modalità cancellazione abilitata, strumenti come Riempimento e Rettangolo sottraggono colori anziché aggiungerli",
	"action.open_from_link": "Apri modello da collegamento...",
	"action.open_from_link.desc": "Apri un modello da un URL blckbn.ch",
	"action.import_obj": "Importa Modello OBJ",
	"action.import_obj.desc": "Importa oggetti da un modello OBJ come mesh",
	"action.add_plugin": "Installa Plugin",
	"action.add_plugin.desc": "Installa un plugin tramite Controllo Azione",
	"action.remove_plugin": "Disinstalla plugin",
	"action.remove_plugin.desc": "Disinstalla un plugin tramite Controllo Azione",
	"action.add_mesh": "Aggiungi mesh",
	"action.add_mesh.desc": "Aggiungi una nuova mesh",
	"action.add_texture_mesh": "Aggiungi Trama Mesh",
	"action.add_texture_mesh.desc": "Aggiungi una nuova Trama Mesh",
	"action.find_replace": "Trova/Sostituisci...",
	"action.find_replace.desc": "Trova e sostituisci parti di nomi",
	"action.hide_everything_except_selection": "Nascondi tutto tranne Selezionato",
	"action.hide_everything_except_selection.desc": "Attiva/disattiva la visibilità su tutti gli elementi tranne quelli selezionati",
	"action.transform_space.normal": "Normale",
	"action.selection_mode": "Modalità Selezione",
	"action.selection_mode.desc": "Cambia il modo in cui gli elementi possono essere selezionati nella finestra",
	"action.selection_mode.object": "Oggetto",
	"action.selection_mode.face": "Faccia",
	"action.selection_mode.vertex": "Vertice",
	"action.create_face": "Crea faccia o bordo",
	"action.create_face.desc": "Crea una nuova faccia o bordo tra i vertici selezionati",
	"action.convert_to_mesh": "Converti in Mesh",
	"action.convert_to_mesh.desc": "Converti gli elementi selezionati in mesh",
	"action.invert_face": "Inverti faccia",
	"action.invert_face.desc": "Inverti le facce selezionate per farle guardare nella direzione opposta",
	"action.extrude_mesh_selection": "Espelli selezione",
	"action.extrude_mesh_selection.desc": "Espelli le parti selezionate della mesh",
	"action.loop_cut": "Taglio Ciclo Continuo",
	"action.loop_cut.desc": "Dividi la mesh in un loop sul bordo selezionato",
	"action.merge_meshes": "Unisci Mesh",
	"action.merge_meshes.desc": "Unisci più mesh in una",
	"action.keyframe_uniform": "Ridimensionamento uniforme",
	"action.keyframe_uniform.desc": "Attiva ridimensionamento uniforme sui fotogrammi chiave selezionati",
	"menu.locator.ignore_inherited_scale": "Ignora scala ereditata",
	"menu.texture.elements": "Applica agli Elementi",
	"uv_editor.transparent_face": "Faccia Trasparente",
	"display.pose_angle": "Angolo posa (solo per anteprima)",
	"data.mesh": "Mesh",
	"dialog.create_texture.type": "Tipo",
	"dialog.create_texture.type.blank": "Vuoto",
	"dialog.create_texture.type.template": "Modello Trama",
	"dialog.create_texture.type.color_map": "Modello Colore Pieno",
	"dialog.sketchfab_uploader.suggested_tags": "Tag Suggeriti",
	"dialog.sketchfab_uploader.category": "Categoria",
	"dialog.sketchfab_uploader.category2": "Categoria 2",
	"layout.restore_backup": "Il tema personalizzato \"%0\" è stato sovrascritto. Clicca qui per ripristinarlo.",
	"layout.borders": "Bordi",
	"action.fill_mode.element": "Elemento",
	"action.inset_mesh_selection": "Inserisci selezione",
	"action.inset_mesh_selection.desc": "Inserisci le parti selezionate della mesh",
	"action.dissolve_edges": "Sciogli bordi",
	"action.dissolve_edges.desc": "Sciogli i bordi selezionati in una mesh e unisci le facce che dividono",
	"action.split_mesh": "Dividi mesh",
	"action.split_mesh.desc": "Dividi le facce selezionate della mesh in una nuova mesh",
	"action.merge_vertices": "Unisci vertici",
	"action.merge_vertices.desc": "Unisci i vertici selezionati nella posizione del primo vertice selezionato",
	"action.view_mode.normal": "Orientamento faccia",
	"action.snap_uv_to_pixels": "Aggancia UV ai pixel",
	"action.snap_uv_to_pixels.desc": "Aggancia i vertici UV selezionati alla griglia pixel",
	"menu.file.import.import_open_project": "Importa progetto aperto",
	"menu.help.unlock_projects": "Sblocca tutti i progetti",
	"status_bar.selection.faces": "%0 Volti",
	"status_bar.selection.vertices": "%0 Vertici",
	"message.merged_vertices": "Trovati e uniti %0 vertici in %1 posizioni",
	"settings.vertex_merge_distance": "Vertice Distanza di unione",
	"settings.vertex_merge_distance.desc": "Distanza entro cui i vertici vengono uniti tramite unione per distanza",
	"settings.show_only_selected_uv": "Mostra solo UV selezionati",
	"settings.show_only_selected_uv.desc": "Per impostazione predefinita, nell'editor UV vengono visualizzate solo le facce UV selezionate",
	"action.merge_vertices.merge_all": "Unisci tutto",
	"action.merge_vertices.merge_all_in_center": "Unisci tutto al centro",
	"action.merge_vertices.merge_by_distance": "Unisci per distanza",
	"action.merge_vertices.merge_by_distance_in_center": "Unisci per distanza al centro",
	"action.uv_rotate_left": "Ruota UV a sinistra",
	"action.uv_rotate_left.desc": "Ruota le facce UV selezionate in senso antiorario",
	"action.uv_rotate_right": "Ruota UV a destra",
	"action.uv_rotate_right.desc": "Ruota le facce UV selezionate in senso orario",
	"menu.uv.display_uv": "Visualizza UV",
	"menu.uv.display_uv.selected_faces": "Facce Selezionate",
	"menu.uv.display_uv.selected_elements": "Tutte le Facce",
	"menu.uv.display_uv.all_elements": "Tutte le facce su tutte Elementi",
	"menu.paste.face": "Faccia UV",
	"menu.paste.mesh_selection": "Selezione mesh",
	"menu.paste.outliner": "Elementi",
	"uv_editor.show_all_faces": "Mostra tutte le facce",
	"uv_editor.show_selected_faces": "Mostra facce selezionate",
	"status_bar.selection.edges": "%0 Bordi",
	"action.selection_mode.edge": "Bordo",
	"message.cannot_re_import.title": "Il modello non può essere reimportato",
	"message.cannot_re_import.message": "Il formato del modello esportato non può essere nuovamente importato in Blockbench. Assicurati di salvare il tuo modello come file di progetto.",
	"generic.default": "Predefinito",
	"units.pixels_per_meter": "%0 Pixel per Metro",
	"mode.pose": "Posa",
	"modifier_actions.resize_both_sides": "Ridimensiona in entrambe le direzioni",
	"modifier_actions.resize_one_side": "Ridimensiona in una direzione",
	"modifier_actions.draw_line": "Disegna linea",
	"modifier_actions.drag_without_snapping": "Trascina senza agganciare",
	"modifier_actions.stretch_keyframes": "Allunga fotogrammi chiave",
	"modifier_actions.resize_background": "Ridimensiona sfondo",
	"modifier_actions.select_multiple": "Seleziona più",
	"modifier_actions.select_range": "Seleziona intervallo",
	"modifier_actions.drag_to_duplicate": "Trascina per duplicare",
	"modifier_actions.uniform_scaling": "Scala uniforme",
	"modifier_actions.snap_direction": "Direzione di aggancio",
	"message.no_valid_elements": "Nessun elemento valido selezionato...",
	"dialog.add_primitive.shape.plane": "Piano",
	"dialog.save_angle.rotation_mode": "Modalità di rotazione",
	"dialog.save_angle.rotation": "Rotazione",
	"dialog.save_angle.fov": "FOV",
	"settings.hide_tab_bar": "Nascondi automaticamente la barra delle schede",
	"settings.hide_tab_bar.desc": "Nascondi la barra delle schede quando è presente solo una scheda open",
	"settings.status_bar_modifier_keys": "Suggerisci tasti modificatori nella barra di stato",
	"settings.status_bar_modifier_keys.desc": "Visualizza tasti modificatori suggeriti in base al contesto nella barra di stato",
	"settings.ground_plane": "Piano Terra",
	"settings.ground_plane.desc": "Mostra un piano del pavimento sotto il modello",
	"settings.preview_paste_behavior": "Comportamento predefinito per incollare nella finestra",
	"settings.preview_paste_behavior.desc": "Seleziona il comportamento quando incolli qualcosa nella finestra in modalità Modifica e sono disponibili più opzioni",
	"settings.preview_paste_behavior.always_ask": "Chiedi sempre",
	"action.new_window": "Nuova Finestra",
	"action.new_window.desc": "Apri una nuova finestra di Blockbench",
	"action.export_collada": "Esporta Collada Modello (dae)",
	"action.export_collada.desc": "Esporta modello e animazioni come file dae per utilizzarli in altre applicazioni 3D",
	"action.paint_mode_uv_overlay": "Sovrapponi UV",
	"action.paint_mode_uv_overlay.desc": "Visualizza la mappa UV come sovrapposizione in modalità pittura",
	"action.bake_animation_into_model": "Cuoci animazione in modello",
	"action.bake_animation_into_model.desc": "Cuoci il frame dell'animazione attualmente visualizzato nel modello. Applica solo rotazione e posizione, la scala viene ignorata.",
	"action.keyframe_interpolation.step": "Passaggio",
	"action.set_ik_target": "Imposta target IK",
	"action.set_ik_target.desc": "Seleziona l'osso target che deve essere spostato da questo oggetto nullo tramite cinematica inversa",
	"menu.action_control.type.tab": "Scheda",
	"menu.action_control.type.angle": "Angolo Telecamera",
	"menu.action_control.recent_in_streamer_mode": "Sicuro? La modalità Streamer è attivata",
	"menu.action_control.recent_in_streamer_mode.desc": "Sicuro di voler visualizzare i modelli recenti?",
	"menu.tools": "Strumenti",
	"menu.file.recent.more": "Visualizza altro...",
	"menu.null_object.lock_ik_target_rotation": "Blocca rotazione target IK",
	"menu.animation_file.import_remaining": "Importa rimanente dal file",
	"edit.loop_cut.offset": "Offset",
	"edit.extrude_mesh_selection.extend": "Estendi",
	"cube.color.pink": "Rosa",
	"cube.color.silver": "Argento",
	"dialog.plugins.offline": "Nessuna connessione Internet",
	"dialog.create_texture.pixel_density": "Densità Pixel",
	"dialog.create_texture.pixel_density.desc": "Densità pixel della trama, in pixel al metro. La dimensione della trama può variare a seconda della quantità e delle dimensioni degli elementi.",
	"panel.skin_pose": "Posa",
	"panel.skin_pose.none": "Nessuno",
	"panel.skin_pose.natural": "Naturale",
	"panel.skin_pose.walking": "Camminando",
	"panel.skin_pose.crouching": "Accovacciato",
	"panel.skin_pose.sitting": "Seduto",
	"panel.skin_pose.jumping": "Saltando",
	"panel.skin_pose.aiming": "Mirando",
	"edit.loop_cut.direction": "Direzione",
	"data.texture_mesh": "Trama Mesh",
	"generic.left": "Sinistra",
	"generic.right": "Destra",
	"mode.start.quick_setup": "Configurazione Rapida",
	"mode.start.keymap": "Mappa Tastiera",
	"mode.start.quick_setup.more_themes": "Altro...",
	"dialog.resize_texture.animation_frames": "Fotogrammi Animazione",
	"dialog.export_emission_map.title": "Esporta mappa di emissione",
	"dialog.export_emission_map.format": "Formato",
	"dialog.export_emission_map.format.luminance": "Luminanza",
	"dialog.export_emission_map.format.luminance_inverted": "Luminanza Invertita",
	"dialog.export_emission_map.format.colors": "Colori",
	"dialog.export_emission_map.threshold": "Soglia Trasparenza",
	"dialog.export_emission_map.round_up": "Arrotonda per eccesso a %0 x %1",
	"dialog.export_emission_map.flip_y": "Inverti Asse Y",
	"dialog.select.type": "Tipo di elemento",
	"dialog.create_texture.max_edge_angle": "Soglia angolo bordo",
	"dialog.create_texture.max_edge_angle.desc": "L'angolo massimo tra due facce a cui saranno ancora combinate",
	"dialog.create_texture.max_island_angle": "Soglia angolo isola",
	"dialog.create_texture.max_island_angle.desc": "L'angolo massimo che può essere combinato nella stessa isola UV",
	"settings.mobile_panel_side": "Lato pannello mobile",
	"settings.mobile_panel_side.desc": "Seleziona su quale lato dei pannelli dello schermo vengono visualizzati quando si utilizza Blockbench in orientamento orizzontale",
	"settings.obj_face_export_mode": "Modalità esportazione faccia OBJ",
	"settings.obj_face_export_mode.desc": "Scegli di consentire all'esportatore OBJ di convertire tutte le facce in tris o quads",
	"settings.obj_face_export_mode.both": "Predefinito",
	"settings.obj_face_export_mode.tris": "Converti in Tris",
	"settings.obj_face_export_mode.quads": "Converti in Quad",
	"action.seam_tool": "Strumento Cucitura",
	"action.seam_tool.desc": "Strumento per definire cuciture UV sui bordi della mesh",
	"action.resolve_group": "Risolvi gruppo",
	"action.resolve_group.desc": "Risolvi il gruppo mantenendo i suoi figli nello stesso posto",
	"action.move_to_group": "Sposta nel gruppo",
	"action.move_to_group.desc": "Sposta gli elementi selezionati in un diverso gruppo outliner",
	"action.select_seam": "Seleziona cucitura UV",
	"action.select_seam.desc": "Seleziona la modalità cucitura UV per i bordi selezionati",
	"action.select_seam.auto": "Auto",
	"action.select_seam.join": "Unisci",
	"action.select_seam.divide": "Dividi",
	"action.adjust_brightness_contrast": "Regola luminosità e contrasto...",
	"action.adjust_brightness_contrast.desc": "Regola luminosità e contrasto della texture selezionata",
	"action.adjust_saturation_hue": "Regola saturazione e tonalità...",
	"action.adjust_saturation_hue.desc": "Regola saturazione e tonalità della texture selezionata",
	"action.invert_colors": "Inverti Colori",
	"action.invert_colors.desc": "Inverti tutti i colori della texture selezionata",
	"action.adjust_curves": "Regola Curve...",
	"action.adjust_curves.desc": "Regola le curve di luminosità della trama selezionata",
	"action.flip_texture_x": "Capovolgi Orizzontalmente",
	"action.flip_texture_y": "Capovolgi Verticalmente",
	"action.resize_texture": "Ridimensiona Trama...",
	"action.view_mode.uv": "Anteprima UV",
	"action.append_to_template": "Aggiungi elementi al modello...",
	"action.append_to_template.desc": "Aggiungi gli elementi attualmente selezionati al modello di trama",
	"action.move_texture_with_uv": "Sposta Trama con UV",
	"action.move_texture_with_uv.desc": "Sposta la trama del viso quando trascini le facce UV",
	"action.timeline_setups": "Impostazioni Linea Temporale",
	"action.save_timeline_setup": "Salva Impostazioni Linea Temporale...",
	"action.save_timeline_setup.desc": "Salva un preset per gli animatori e i canali attualmente selezionati",
	"menu.texture": "Trama",
	"menu.texture.render_mode.default": "Predefinito",
	"menu.texture.merge_onto_texture": "Unisci alla trama sopra",
	"menu.animation.unload": "Scarica",
	"panel.timeline": "Linea Temporale",
	"action.pan_tool": "Strumento Panoramico",
	"action.pan_tool.desc": "Strumento per navigare nella finestra e nell'editor della trama",
	"mode.start.recent.favorite": "Segna come preferito",
	"mode.start.info": "Informazioni",
	"mode.start.target": "Destinazione",
	"mode.start.start": "Inizio",
	"mode.start.create_new": "Crea Nuovo Modello",
	"mode.start.format.informations": "Buono a sapersi:",
	"mode.start.format.resources": "Risorse:",
	"format.free.info.meshes": "In questo formato, puoi creare modelli low poly usando cubi e mesh di forma personalizzata.",
	"format.free.info.limitation": "I modelli non possono essere caricati in giochi che necessitano di formati specializzati, come Minecraft.",
	"format.skin.info.skin": "Questo formato è progettato per creare skin Minecraft e texture di entità.",
	"format.skin.info.model": "Il modello non può essere modificato. Per apportare modifiche al modello, convertilo prima in un formato diverso tramite **File** > **Converti progetto**.",
	"format.java_block.info.rotation": "Le rotazioni sono limitate a incrementi di 22,5 gradi e un asse per elemento",
	"format.java_block.info.size": "Il modello è limitato a una dimensione di 3 per 3 per 3 blocchi. Tuttavia, le impostazioni di visualizzazione possono ingrandire i modelli degli oggetti",
	"format.java_block.info.animation": "Questo formato non supporta le animazioni in Minecraft vanilla. Se stai creando una mod, puoi usare GeckoLib per animare i modelli. In caso contrario, l'unico modo per animare è cambiare il modello usando comandi o texture animate.",
	"format.bedrock.info.textures": "Ogni modello può avere una sola texture",
	"format.bedrock_block": "Blocco Bedrock",
	"format.bedrock_block.desc": "Modello di blocco per Minecraft Bedrock Edition",
	"format.modded_entity.info.integer_size": "La dimensione dei singoli cubi è limitata agli interi.",
	"format.modded_entity.info.format": "I modelli sono scritti in codice Java anziché in strutture dati dedicate come tutti gli altri formati di esportazione di Blockbench.",
	"format.optifine_entity.info.optifine_required": "Gli utenti senza OptiFine installato non vedranno il modello.",
	"format.optifine_entity.info.pivots": "I perni ossei sono bloccati, quindi è una buona idea lasciarli intatti.",
	"format_category.low_poly": "Low-Poly",
	"format_category.minecraft": "Minecraft",
	"format_category.other": "Altro",
	"format_category.loaders": "Caricatori",
	"message.recover_backup.recover": "Recupera",
	"message.invalid_characters.title": "Percorso non valido",
	"message.invalid_characters.message": "Il percorso del file importato contiene caratteri non validi, lettere maiuscole o spazi vuoti. I caratteri supportati sono: %0",
	"dialog.share_model.thumbnail": "Miniatura",
	"dialog.skin.high_res_texture": "Nota che le skin con la risoluzione selezionata non funzioneranno come normali skin di Minecraft. Seleziona una risoluzione inferiore.",
	"settings.allow_display_slot_mirror": "Consenti mirroring slot display",
	"settings.allow_display_slot_mirror.desc": "Consenti mirroring slot display per modelli di oggetti Java. ATTENZIONE: Funziona solo in Minecraft 1.14 o versioni precedenti o in casi particolari.",
	"action.switch_tabs": "Cambia Scheda",
	"action.switch_tabs.desc": "Passa da una scheda aperta all'altra. Tieni premuto shift per scorrere nella direzione opposta.",
	"action.unselect_all": "Deseleziona tutto",
	"action.save_palette": "Salva Tavolozza...",
	"action.save_palette.desc": "Salva la tavolozza dei colori corrente all'interno di Blockbench per un uso successivo",
	"action.keyframe_column_create": "Crea colonna fotogramma chiave",
	"action.keyframe_column_create.desc": "Inserisci tutti i canali nella timeline al timecode corrente, se hanno già fotogrammi chiave",
	"action.keyframe_column_select": "Seleziona colonna fotogramma chiave",
	"action.keyframe_column_select.desc": "Seleziona tutti i fotogrammi chiave nella timeline lungo una colonna sotto la testina di riproduzione",
	"menu.uv": "UV",
	"menu.keyframe": "Fotogramma",
	"menu.palette.load.update": "Aggiorna Tavolozza",
	"menu.palette.load.update.desc": "Aggiorna questa palette con i colori della palette Blockbench corrente",
	"menu.timeline_marker.set_time": "Imposta Tempo...",
	"uv_editor.scale_uv": "Scala UV",
	"action.preview_scene": "Anteprima Scena",
	"action.preview_scene.desc": "Cambia la scena di anteprima del modello",
	"preview_scene.minecraft_overworld": "Overworld",
	"preview_scene.minecraft_nether": "Inferiore",
	"preview_scene.minecraft_end": "Fine",
	"dialog.project.modded_entity_flip_y": "Inverti Asse Y",
	"preview_scene.studio": "Studio",
	"format.image": "Immagine",
	"modifier_actions.set_copy_source": "Imposta origine copia",
	"message.load_images.title": "Carica Immagini",
	"message.load_images.edit_image": "Modifica Immagine",
	"dialog.add_primitive.align_edges": "Allinea bordi",
	"dialog.flip_animation.show_in_timeline": "Mostra ossa modificate nella timeline",
	"settings.default_cube_size": "Dimensioni cubo",
	"settings.default_cube_size.desc": "Imposta le dimensioni predefinite del cubo quando ne crei uno nuovo",
	"settings.uniform_keyframe": "Fotogrammi Scala Uniforme",
	"settings.uniform_keyframe.desc": "Imposta i fotogrammi di scala su scala uniforme per impostazione predefinita",
	"settings.nearest_rectangle_select": "Seleziona rettangolo: bordo più vicino",
	"settings.nearest_rectangle_select.desc": "Aggancia le selezioni rettangolo al bordo pixel più vicino, come in GIMP, invece che all'intero pixel.",
	"settings.pick_color_opacity": "Seleziona l'opacità del colore",
	"settings.pick_color_opacity.desc": "Seleziona l'opacità del colore con il Selettore colore e impostala come opacità del pennello",
	"settings.paint_with_stylus_only": "Disegna solo con lo stilo",
	"settings.paint_with_stylus_only.desc": "Utilizza lo stilo solo per dipingere, riserva il mouse o l'input touch per la navigazione.",
	"action.copy_brush_mode": "Copia modalità pennello",
	"action.copy_brush_mode.copy": "Copia",
	"action.copy_brush_mode.pattern": "Modello",
	"action.copy_brush_mode.sample": "Campione",
	"action.brush_shape": "Forma Pennello",
	"action.brush_shape.square": "Quadrato",
	"action.brush_shape.circle": "Cerchio",
	"action.blend_mode": "Modalità Fusione",
	"action.blend_mode.default": "Predefinito",
	"action.blend_mode.set_opacity": "Imposta Opacità",
	"action.blend_mode.color": "Colore",
	"action.blend_mode.behind": "Dietro",
	"action.blend_mode.multiply": "Moltiplica",
	"action.blend_mode.divide": "Dividi",
	"action.blend_mode.add": "Aggiungi",
	"action.blend_mode.subtract": "Sottrai",
	"action.blend_mode.screen": "Schermo",
	"action.blend_mode.overlay": "Sovrapposizione",
	"action.blend_mode.hard_light": "Luce Intensa",
	"action.blend_mode.difference": "Differenza",
	"action.copy_brush": "Copia Pennello",
	"action.copy_brush.desc": "Pennello per clonare parti della tua texture o disegnare pattern. Tieni premuto Ctrl e fai clic per selezionare una sorgente di copia.",
	"action.validator_window": "Visualizza problemi modello...",
	"action.validator_window.desc": "Apri il validatore, che elenca i problemi con il modello corrente.",
	"action.cancel_gif": "Annulla GIF",
	"menu.text_edit.copy_vector": "Copia Vettore",
	"menu.brush_presets.dialog": "Pennello Predefinito...",
	"menu.brush_presets.pixel_brush": "Pennello Pixel",
	"menu.brush_presets.smooth_brush": "Pennello Liscio",
	"menu.texture.edit_in_blockbench": "Modifica in Blockbench",
	"menu.mirror_painting.axis": "Asse",
	"menu.mirror_painting.axis.desc": "Seleziona su quale asse verranno specchiate le pennellate",
	"menu.mirror_painting.global": "Simmetria Globale",
	"menu.mirror_painting.global.desc": "Specchio pittura attivato sul modello nello spazio globale",
	"menu.mirror_painting.local": "Simmetria Locale",
	"menu.mirror_painting.local.desc": "Specchio pittura attivato nello spazio locale per ogni elemento",
	"menu.mirror_painting.texture_frames": "Ripeti sui fotogrammi del flipbook",
	"menu.mirror_painting.texture_frames.desc": "Applica pennellate di vernice speculari a ogni fotogramma di texture animate",
	"format.bedrock_block.info.size_limit": "La dimensione totale di un blocco è limitata a 30 pixel in tutte le dimensioni. Il limite può essere decentrato in tutte le direzioni di 7 pixel dal centro del blocco.",
	"format.bedrock_block.info.textures": "È possibile applicare più texture a cubi diversi in Blockbench, ma è richiesta una configurazione aggiuntiva nel pacchetto di comportamento per funzionare correttamente nel gioco.",
	"format.image.desc": "Modifica le immagini nell'editor di immagini 2D",
	"generic.delete_all": "Elimina tutto",
	"message.child_model_only.open": "Apri Genitore",
	"message.child_model_only.open_with_textures": "Apri genitore e adotta texture",
	"dialog.project.credit": "Credito",
	"dialog.convert_project.create_copy": "Crea copia",
	"dialog.texture.frame_time": "Tempo Fotogramma",
	"dialog.texture.frame_time.desc": "Imposta per quanto tempo ogni fotogramma sarà visibile, in tick. Ogni tick è 1/20 di secondo.",
	"dialog.texture.frame_interpolate": "Interpola",
	"dialog.texture.frame_interpolate.desc": "Interpola tra i fotogrammi dell'animazione tramite dissolvenza incrociata al fotogramma successivo",
	"dialog.texture.frame_order_type": "Modalità Ripetizione",
	"dialog.texture.frame_order_type.loop": "Ripetizione",
	"dialog.texture.frame_order_type.backwards": "Ripeti all'indietro",
	"dialog.texture.frame_order_type.back_and_forth": "Avanti e indietro",
	"dialog.texture.frame_order_type.custom": "Ordine personalizzato",
	"dialog.texture.frame_order": "Ordine Fotogrammi",
	"dialog.texture.frame_order.desc": "Imposta un ordine dei fotogrammi personalizzato elencando gli indici dei fotogrammi in un nuovo ordine. Gli indici dei fotogrammi iniziano da 0 con il primo fotogramma.",
	"dialog.select.mode": "Modalità",
	"dialog.select.mode.new": "Nuova selezione",
	"dialog.select.mode.add": "Aggiungi a Selezionato",
	"dialog.select.mode.remove": "Rimuovi da Selezionato",
	"dialog.select.mode.in_selection": "Seleziona solo da Selezionato",
	"dialog.predicate_overrides.model": "Modello",
	"dialog.predicate_overrides.predicates": "Predicati",
	"dialog.predicate_overrides.variants": "Varianti",
	"dialog.predicate_overrides.start_value": "Inizia",
	"dialog.predicate_overrides.add_override": "Aggiungi override",
	"dialog.predicate_overrides.add_predicate": "Aggiungi predicato",
	"dialog.predicate_overrides.generate_overrides": "Genera override",
	"dialog.predicate_overrides.confirm_delete": "Sicuro di voler eliminare tutti gli override?",
	"dialog.predicate_overrides.predicate.angle": "Angolo bussola",
	"dialog.predicate_overrides.predicate.blocking": "Sta bloccando",
	"dialog.predicate_overrides.predicate.broken": "È interrotto",
	"dialog.predicate_overrides.predicate.cast": "È lanciato",
	"dialog.predicate_overrides.predicate.cooldown": "Tempo di recupero",
	"dialog.predicate_overrides.predicate.damage": "Danni",
	"dialog.predicate_overrides.predicate.damaged": "È danneggiato",
	"dialog.predicate_overrides.predicate.lefthanded": "È mancino",
	"dialog.predicate_overrides.predicate.pull": "Importo di tiro",
	"dialog.predicate_overrides.predicate.pulling": "Sta tirando",
	"dialog.predicate_overrides.predicate.charged": "È caricato",
	"dialog.predicate_overrides.predicate.firework": "Fuochi d'artificio",
	"dialog.predicate_overrides.predicate.throwing": "Pronto a lanciare",
	"dialog.predicate_overrides.predicate.time": "Ora del giorno",
	"dialog.predicate_overrides.predicate.custom_model_data": "Dati modello personalizzati",
	"dialog.predicate_overrides.predicate.level": "Livello luce",
	"dialog.predicate_overrides.predicate.filled": "Livello riempimento bundle",
	"dialog.predicate_overrides.predicate.tooting": "Suonare Tromba",
	"settings.model_export_scale": "Scala di esportazione del modello",
	"settings.model_export_scale.desc": "Fattore di riduzione della scala dei modelli glTF, DAE e FBX esportati. Il valore predefinito è 16, che converte 16 unità Blockbench in 1 metro nell'esportazione.",
	"action.export_fbx": "Esporta modello FBX",
	"action.export_fbx.desc": "Esporta modello e animazioni come file fbx per utilizzarli in altre applicazioni 3D e motori di gioco",
	"action.center_lateral": "Centra lateralmente",
	"action.center_lateral.desc": "Centra gli elementi selezionati sugli assi X e Z",
	"action.adjust_opacity": "Regola opacità...",
	"action.adjust_opacity.desc": "Regola l'opacità della texture selezionata",
	"action.rotate_texture_cw": "Ruota in senso orario",
	"action.rotate_texture_ccw": "Ruota in senso antiorario",
	"action.predicate_overrides": "Modifica sostituzioni predicato...",
	"action.predicate_overrides.desc": "Seleziona i modelli per sostituire questo modello in base alle condizioni selezionate",
	"action.auto_set_cullfaces": "Imposta automaticamente le Cullface",
	"action.auto_set_cullfaces.desc": "Genera automaticamente le cullface per nascondere le facce quando sono coperte dal blocco adiacente.",
	"menu.texture.edit_externally": "Modifica esternamente",
	"menu.mirror_painting.texture": "Simmetria editor 2D",
	"menu.mirror_painting.texture.desc": "Abilita la pittura speculare nello spazio 2D sull'immagine o sulla texture",
	"menu.animator.rotation_global": "Ruota nello spazio globale",
	"uv_editor.face_properties": "Proprietà faccia",
	"uv_editor.face_properties.material_instance": "Istanza materiale",
	"uv_editor.tint.info": "La tinta può essere abilitata su una faccia per dire a Minecraft di colorarla. In Vanilla, la tinta può essere usata solo da blocchi specifici come foglie e polvere di redstone e può avere solo un valore di 0.",
	"uv_editor.cullface.info": "L'abilitazione di cullface dice a una faccia su un blocco di non renderizzare se un altro blocco completo viene posizionato accanto ad essa nella direzione specificata nel tuo mondo di Minecraft. Questo può essere usato per ottimizzare le prestazioni.",
	"uv_editor.material_instance.info": "Le istanze di materiale possono essere impostate su un nome definito dall'utente. Quel nome può essere usato nel file JSON del blocco nel pacchetto di comportamento per assegnare una particolare texture e materiale alla faccia.",
	"display.reference.frame_invisible": "Cornice dell'oggetto (invisibile)",
	"data.settings_profile": "Profilo",
	"message.display_skin.invalid_name": "Impossibile trovare l'account Minecraft con il nome \"%0\".",
	"dialog.load_plugins_from_query.title": "Carica plugin",
	"dialog.load_plugins_from_query.text": "Hai utilizzato un collegamento che richiede l'installazione di plugin. Vuoi installarli?",
	"dialog.select_model.title": "Seleziona modello",
	"dialog.select_model.bones": "Ossa",
	"dialog.select_model.cubes": "Cubi",
	"dialog.settings.create_profile": "Crea profilo...",
	"settings_profile.confirm_delete": "Sicuro di voler eliminare questo profilo di impostazioni?",
	"settings_profile.condition.type.selectable": "Selezionabile manualmente",
	"settings.interface_mode": "Modalità UI",
	"settings.interface_mode.desc": "Modalità Interfaccia",
	"settings.interface_mode.auto": "Automatico",
	"settings.interface_mode.desktop": "Desktop",
	"settings.interface_mode.mobile": "Mobile",
	"settings.paint_through_transparency": "Dipingi su trasparenza",
	"settings.paint_through_transparency.desc": "Dipingi attraverso i pixel trasparenti quando è abilitato Blocca canale alfa",
	"action.tab_overview": "Panoramica schede",
	"action.tab_overview.desc": "Visualizza tutte le schede aperte in una griglia e passa a una",
	"action.slider_color_red": "Colore rosso",
	"action.slider_color_green": "Colore verde",
	"action.slider_color_blue": "Colore blu",
	"action.add_animation_controller": "Aggiungi controllo animazione",
	"action.add_animation_controller.desc": "Crea un controllo animazione vuoto",
	"action.animation_controller_preview_mode": "Anteprima Controllo",
	"action.animation_controller_preview_mode.paused": "In pausa",
	"action.animation_controller_preview_mode.manual": "Anteprima Manuale",
	"action.animation_controller_preview_mode.play": "Auto Riproduzione",
	"action.keyframe_interpolation.bezier": "Bézier",
	"action.keyframe_bezier_linked": "Collega maniglie Bézier",
	"action.keyframe_bezier_linked.desc": "Collega la maniglia Bézier del fotogramma chiave destro e sinistro",
	"action.reset_keyframe_handles": "Reimposta maniglie fotogramma",
	"action.reset_keyframe_handles.desc": "Reimposta le maniglie Bézier dei fotogrammi selezionati",
	"action.looped_animation_playback": "Riproduzione in loop",
	"action.looped_animation_playback.desc": "Visualizza l'anteprima delle animazioni in un ciclo infinito",
	"timeline.bind_to_actor": "Collega all'attore",
	"animation_controllers.select_preset": "Seleziona un preset controller...",
	"animation_controllers.state.animations": "Animazioni",
	"animation_controllers.state.particles": "Particelle",
	"animation_controllers.state.sounds": "Suoni",
	"animation_controllers.state.on_entry": "Ingresso",
	"animation_controllers.state.on_exit": "Uscita",
	"animation_controllers.state.transitions": "Transizioni",
	"animation_controllers.state.condition": "Condizione",
	"animation_controllers.state.blend_transition": "Tempo di fusione",
	"animation_controllers.state.shortest_path": "Fusione per percorso più breve",
	"animation_controllers.state.edit_transition": "Modifica transizione",
	"menu.color_picker.picker_type": "Tipo di selettore",
	"menu.color_picker.picker_type.square": "Quadrato",
	"menu.color_picker.picker_type.wheel": "Wheel",
	"menu.color_picker.slider_mode": "Modalità cursore",
	"menu.color_picker.slider_mode.hsv": "Tonalità, Saturazione, Valore",
	"menu.color_picker.slider_mode.rgb": "Rosso, Verde, Blu",
	"menu.texture.render_mode.additive": "Additivo",
	"panel.color.picker_options": "Opzioni selettore colore",
	"panel.animation_controllers": "Controllo animazione",
	"display.preset.armor_stand": "Terra (supporto armatura)",
	"data.file_path": "Percorso File",
	"dialog.extrude.orientation": "Orientamento",
	"dialog.extrude.orientation.upright": "Verticale",
	"dialog.extrude.orientation.flat": "Piatto",
	"dialog.scale.box_uv_warning": "Il ridimensionamento di un modello UV Box potrebbe interrompere l'UV del tuo modello. Invece, prova a ridimensionare il tuo modello esternamente o passa alla modalità UV per faccia in File > Progetto.",
	"dialog.create_gif.format": "Formato",
	"dialog.create_gif.format.gif": "GIF",
	"dialog.create_gif.format.png_sequence": "Sequenza PNG",
	"dialog.create_gif.pixelate": "Pixelate",
	"dialog.create_gif.bg_image": "Immagine di sfondo",
	"dialog.create_gif.turn.desc": "Ruota il modello durante la registrazione. Utilizza valori negativi per ruotare il modello in senso orario. Un valore di 60 corrisponde a una rotazione al secondo.",
	"settings_profile.condition": "Condizione",
	"settings_profile.condition.type.file_path.desc": "Utilizza la sintassi delle espressioni regolari per far corrispondere il percorso del file del progetto corrente. Utilizza le barre per le directory",
	"settings.only_selected_bezier_handles": "Mostra solo le maniglie di Bézier selezionate",
	"settings.only_selected_bezier_handles.desc": "Nascondi le maniglie dei fotogrammi chiave di Bézier che non sono attualmente selezionati",
	"settings.embed_textures": "Incorpora le texture",
	"settings.embed_textures.desc": "Incorpora il contenuto del file texture nei file .bbmodel",
	"action.selection_mode.cluster": "Cluster",
	"dialog.copied_to_clipboard": "Copiato negli appunti",
	"data.reference_image": "Immagine di riferimento",
	"message.delete_reference_image": "Sei sicuro di voler eliminare questa immagine di riferimento? Questa operazione non può essere annullata.",
	"message.add_reference_image.message": "Seleziona dove caricare l'immagine di riferimento",
	"message.add_reference_image.project": "Aggiungi a questo progetto",
	"message.add_reference_image.app": "Aggiungi a tutti i progetti",
	"message.import_particle_texture.import": "Importa texture particella",
	"message.import_particle_texture.message": "Vuoi importare un file texture da utilizzare per la tua particella?",
	"message.save_codec_selector.title": "Salva formato modello",
	"message.save_codec_selector.message": "Seleziona un formato per salvare il modello in.",
	"message.save_codec_selector.project_file": "Progetto Blockbench (.bbmodel)",
	"message.save_codec_selector.both": "Entrambi",
	"message.display_skin.username": "Nome utente (Java)",
	"message.palette_locked": "La palette è bloccata",
	"dialog.project.default_uv_mode": "Modalità UV predefinita",
	"dialog.project.default_uv_mode.description": "Modalità UV predefinita del progetto. La modalità UV può anche essere modificata per cubo.",
	"dialog.export_options.title": "Opzioni di esportazione",
	"dialog.edit_texture.preview": "Anteprima",
	"dialog.proportional_editing.range": "Intervallo",
	"dialog.proportional_editing.falloff": "Decadenza",
	"dialog.proportional_editing.falloff.linear": "Lineare",
	"dialog.proportional_editing.falloff.hermite_spline": "Liscio",
	"dialog.proportional_editing.falloff.constant": "Costante",
	"dialog.proportional_editing.selection": "Selezione",
	"dialog.proportional_editing.selection.linear": "Distanza lineare",
	"dialog.proportional_editing.selection.connections": "Connessioni",
	"dialog.mirror_painting_texture_center.middle": "Centro",
	"dialog.mirror_painting_texture_center.custom": "Personalizzato",
	"dialog.settings.reset_to_default": "Reimposta a Predefinito",
	"keybindings.item.num_slider.increase": "Aumenta",
	"keybindings.item.num_slider.decrease": "Diminuisci",
	"settings.always_show_splash_art": "Mostra sempre Splash Art",
	"settings.always_show_splash_art.desc": "Mostra sempre Splash Art nella schermata iniziale",
	"action.slider_palette_color": "Cambia colore tavolozza",
	"action.slider_palette_color.desc": "Cambia i colori nella tavolozza",
	"action.proportional_editing": "Modifica proporzionale",
	"action.proportional_editing.desc": "Influisce in modo proporzionale sui vertici circostanti quando si modificano parti di una mesh",
	"action.limit_to_palette": "Limita a tavolozza",
	"action.limit_to_palette.desc": "Limita i colori della texture a quelli nella palette attualmente caricata",
	"action.edit_reference_images": "Modifica immagini di riferimento",
	"action.edit_reference_images.desc": "Attiva la modalità immagine di riferimento per aggiungere o modificare immagini di riferimento e progetti",
	"action.add_reference_image": "Aggiungi immagine di riferimento",
	"action.reference_image_from_clipboard": "Immagine di riferimento dagli appunti",
	"action.reference_image_list": "Immagini di riferimento",
	"action.connect_uv_faces": "Collega facce UV",
	"action.connect_uv_faces.desc": "Collega le facce UV selezionate all'ultima faccia UV selezionata",
	"action.merge_uv_vertices": "Unisci vertici UV",
	"action.merge_uv_vertices.desc": "Aggancia i primi vertici UV selezionati agli ultimi vertici UV selezionati",
	"action.bedrock_animation_mode": "Modalità Animazione Bedrock",
	"action.bedrock_animation_mode.desc": "Seleziona la modalità in cui modificare le animazioni per Minecraft: Bedrock Edition",
	"action.bedrock_animation_mode.entity": "Entità",
	"action.bedrock_animation_mode.attachable_first": "Oggetto 1a persona",
	"action.bedrock_animation_mode.attachable_third": "Oggetto 3a persona",
	"timeline.amplify": "Amplifica",
	"menu.options": "Opzioni...",
	"menu.palette.lock_palette": "Blocca Palette",
	"menu.uv.export": "Esporta Mappatura UV",
	"menu.uv.flip_x": "Specchio X",
	"menu.uv.flip_y": "Specchio Y",
	"menu.mirror_painting.enabled": "Abilitato",
	"reference_image.position": "Posizione",
	"reference_image.size": "Dimensione",
	"reference_image.rotation": "Rotazione",
	"reference_image.opacity": "Opacità",
	"reference_image.visibility": "Visibilità",
	"reference_image.clear_mode": "Modalità Cancella",
	"reference_image.layer": "Livello",
	"reference_image.layer.background": "Dietro al modello",
	"reference_image.layer.viewport": "Sopra al modello",
	"reference_image.layer.float": "Sopra all'interfaccia",
	"reference_image.scope": "Ambito",
	"reference_image.scope.project": "Solo questo progetto",
	"reference_image.scope.global": "Tutti i progetti",
	"reference_image.enabled_modes": "Abilitato in modalità",
	"codec.common.encoding": "Codifica",
	"codec.common.armature": "Esporta gruppi come armatura",
	"codec.common.export_animations": "Esporta animazioni",
	"codec.common.embed_textures": "Incorpora trama",
	"preview.center_camera": "Centra telecamera",
	"display.reference.frame_top": "Parte superiore frame elemento",
	"display.reference.frame_top_invisible": "Parte superiore frame elemento (invisibile)",
	"action.proportional_editing_range": "Intervallo di modifica proporzionale",
	"action.proportional_editing_range.desc": "Regola l'intervallo per la modifica proporzionale",
	"action.toggle_all_reference_images": "Nascondi/Mostra tutte le immagini di riferimento",
	"action.toggle_all_reference_images.desc": "Attiva/disattiva la visibilità di tutte le immagini di riferimento contemporaneamente",
	"action.add_animation_controller_state": "Aggiungi stato controller animazione",
	"action.add_animation_controller_state.desc": "Aggiungi un nuovo stato al controller animazione",
	"menu.slider.round_value": "Arrotonda valore",
	"texture.error.too_large": "La risoluzione supera il massimo di %0",
	"dialog.copy_to_clipboard": "Copia negli appunti",
	"dialog.open_url": "Apri URL",
	"reference_image.image": "Immagine",
	"uv_editor.rotate_uv": "Ruota UV",
	"generic.error": "Errore",
	"projects.start_screen": "Schermata iniziale",
	"message.invalid_link.message": "Il modello condiviso \"%0\" che stai tentando di caricare non è valido o è scaduto.",
	"message.plugin_dependencies.title": "Dipendenze del plugin",
	"message.plugin_dependencies.message1": "Il plugin richiede queste dipendenze:",
	"message.plugin_dependencies.message1_update": "Il plugin %0 è stato aggiornato e ora richiede queste dipendenze:",
	"message.plugin_dependencies.message2": "Vuoi installarle per continuare?",
	"message.plugin_dependencies.invalid": "Purtroppo il plugin non può essere installato, ha una dipendenza non valida:",
	"message.preview_scene_load_failed": "Impossibile caricare la scena di anteprima. Controlla la tua connessione Internet.",
	"dialog.convert_project.text1": "Converti il ​​progetto in un formato diverso.",
	"dialog.convert_project.text2": "Usa la conversione a tuo rischio e pericolo. I formati hanno caratteristiche e restrizioni diverse, quindi la conversione in alcuni casi interromperà parti del tuo progetto.",
	"dialog.convert_project.text3": "Non puoi annullare la conversione, ecco perché per impostazione predefinita verrà creata una copia.",
	"dialog.unsaved_work.title": "Lavoro non salvato",
	"dialog.unsaved_work.text": "I seguenti progetti contengono modifiche non salvate. Vuoi salvare le modifiche?",
	"dialog.unsaved_work.discard_all": "Ignora tutto",
	"dialog.unsaved_work.save_all": "Salva tutto",
	"dialog.resize_texture.mode": "Modalità",
	"dialog.resize_texture.mode.crop": "Ritaglia/Espandi",
	"dialog.resize_texture.mode.scale": "Scala",
	"dialog.plugins.is_installed": "Installato",
	"dialog.plugins.is_disabled": "Disattivato",
	"dialog.plugins.disable": "Disattiva",
	"dialog.plugins.enable": "Attiva",
	"dialog.plugins.dependencies": "Dipende da:",
	"dialog.view_backups.open_folder": "Apri cartella",
	"dialog.share_model.reference_images": "Includi immagini di riferimento",
	"dialog.share_model.too_large": "Impossibile caricare: il modello è troppo grande",
	"dialog.share_model.too_large_references": "Impossibile caricare: il modello è troppo grande. Prova senza immagini di riferimento.",
	"settings.stretch_linked": "Allungamento collegamento",
	"settings.stretch_linked.desc": "Allunga il cubo in tutte le direzioni con lo stesso valore",
	"settings.grids": "Mostra griglie",
	"settings.grids.desc": "Mostra o nascondi tutte le griglie 3D",
	"settings.double_click_switch_tools": "Cambia strumenti con doppio clic",
	"settings.double_click_switch_tools.desc": "Fai doppio clic sulla finestra per passare da uno strumento all'altro",
	"settings.outlines_in_paint_mode": "Contorni di selezione in modalità pittura",
	"settings.outlines_in_paint_mode.desc": "Visualizza i contorni di selezione degli elementi in modalità pittura",
	"settings.json_indentation": "Indentazione JSON",
	"settings.json_indentation.desc": "Stile di rientro per i file JSON esportati",
	"settings.json_indentation.tabs": "Schede",
	"settings.json_indentation.spaces_4": "Spazi: 4",
	"settings.json_indentation.spaces_2": "Spazi: 2",
	"action.slider_stretch": "Allunga",
	"action.slider_stretch.desc": "Allunga i cubi in modo moltiplicativo sull'asse %0 senza modificare l'UV",
	"action.view_backups": "Visualizza backup",
	"action.view_backups.desc": "Sfoglia l'elenco dei backup di progetto salvati automaticamente",
	"action.search_outliner": "Cerca Outliner",
	"action.search_outliner.desc": "Cerca nomi di elementi specifici nell'outliner",
	"action.mirror_modeling": "Modellazione speculare",
	"action.mirror_modeling.desc": "Abilita la modellazione speculare sull'asse X. Tutte le modifiche apportate nella finestra verranno riflesse sull'altro lato, a meno che non siano specificatamente disabilitate sull'elemento.",
	"action.allow_element_mirror_modeling": "Consenti la modellazione speculare",
	"action.allow_element_mirror_modeling.desc": "Scegli se gli elementi selezionati possono essere interessati dalla modellazione speculare",
	"action.switch_face_crease": "Cambia piega della faccia",
	"action.switch_face_crease.desc": "Cambia la direzione in cui il quad si piega al centro",
	"action.clear_unused_texture_space": "Cancella spazio texture inutilizzato",
	"action.clear_unused_texture_space.desc": "Cancella parti della trama che non sono mappate UV su alcun elemento",
	"action.split_screen": "Schermo diviso",
	"action.split_screen.desc": "Seleziona una modalità di schermo diviso della finestra di visualizzazione",
	"action.split_screen.single": "Singolo",
	"action.split_screen.double_horizontal": "Doppio orizzontale",
	"action.split_screen.double_vertical": "Doppio verticale",
	"action.split_screen.quad": "Quadruplo",
	"action.split_screen.triple_left": "Triplo a sinistra",
	"action.split_screen.triple_right": "Triplo a destra",
	"action.split_screen.triple_top": "Triplo in alto",
	"action.split_screen.triple_bottom": "Triplo in basso",
	"action.uv_project_from_view": "Progetto UV dalla vista",
	"action.uv_project_from_view.desc": "Genera automaticamente UV per le facce selezionate dalla prospettiva della vista 3D",
	"action.graph_editor_other_graphs": "Visualizza altri grafici",
	"action.graph_editor_other_graphs.desc": "Se i grafici degli assi non selezionati vengono visualizzati",
	"action.graph_editor_include_other_graphs": "Includi altri grafici",
	"action.graph_editor_include_other_graphs.desc": "Se l'editor grafico include i grafici non selezionati nella vista",
	"action.set_ik_source": "Imposta radice IK",
	"action.set_ik_source.desc": "Seleziona l'osso radice della catena che deve essere spostato da questo oggetto nullo tramite cinematica inversa",
	"edit.loop_cut.cuts": "Tagli",
	"panel.element.stretch": "Allunga",
	"preview_scene.minecraft_plains": "Pianure",
	"preview_scene.minecraft_cherry_grove": "Boschetto di ciliegie",
	"preview_scene.minecraft_snowy_tundra": "Tundra Innevata",
	"preview_scene.minecraft_sunset": "Tramonto",
	"preview_scene.minecraft_night": "Notte",
	"preview_scene.minecraft_desert": "Deserto",
	"preview_scene.minecraft_underwater": "Sott'acqua",
	"preview_scene.minecraft_coral_reef": "Barriera Corallina",
	"preview_scene.minecraft_lush_cave": "Grotta Lussureggiante",
	"preview_scene.minecraft_deep_dark": "Buio Profondo",
	"generic.navigate_forward": "Avanti",
	"generic.navigate_back": "Indietro",
	"action.element_render_order": "Ordine Rendering Trasparenza",
	"action.element_render_order.default": "Automatico",
	"action.element_render_order.behind": "Dietro",
	"action.element_render_order.in_front": "Davanti",
	"message.installing_update.title": "Aggiornamento disponibile",
	"message.installing_update.message": "Una nuova versione è pronta per essere installata. Dopo aver chiuso l'app, attendi circa %0 secondi prima di riaprire Blockbench o spegnere il computer, per installare l'aggiornamento.",
	"settings.brush_cursor_2d": "Cursore pennello 2D",
	"settings.brush_cursor_2d.desc": "Visualizza un contorno attorno al pennello nell'area di lavoro 2D",
	"settings.brush_cursor_3d": "Cursore pennello 3D",
	"settings.brush_cursor_3d.desc": "Visualizza un contorno attorno al pennello nell'area di lavoro 3D",
	"settings.cdn_mirror": "Usa CDN Mirror",
	"settings.cdn_mirror.desc": "Usa il mirror CDN per scaricare i plugin. Lo specchio riceve gli aggiornamenti più velocemente e funziona in alcune regioni in cui l'impostazione predefinita non funziona.",
	"data.layer": "Livello",
	"data.panel": "Pannello",
	"generic.confirm_delete": "Sicuro di voler eliminare questo?",
	"format_category.general": "Generale",
	"modifier_actions.no_uniform_scaling": "Ridimensionamento libero",
	"message.texture_refresh_conflict.title": "Versioni trama in conflitto",
	"message.texture_refresh_conflict.message": "Il file trama potrebbe contenere modifiche in conflitto con la versione di Blockbench",
	"message.texture_refresh_conflict.keep_ours": "Mantieni la versione di Blockbench",
	"message.texture_refresh_conflict.keep_theirs": "Carica il file e scarta tutte le modifiche e i livelli in Blockbench",
	"message.group_required_to_animate": "Non puoi animare questo tipo di elemento. Crea un gruppo per animarlo.",
	"dialog.texture.uv_size": "Dimensioni UV",
	"dialog.advanced_screenshot.angle_preset": "Preimpostazione angolo",
	"dialog.advanced_screenshot.resolution": "Risoluzione",
	"dialog.advanced_screenshot.zoom_to_fit": "Adatta Zoom",
	"dialog.advanced_screenshot.zoom": "Zoom / Lunghezza focale",
	"dialog.advanced_screenshot.anti_aliasing": "Anti-aliasing",
	"dialog.advanced_screenshot.anti_aliasing.off": "Off",
	"dialog.advanced_screenshot.anti_aliasing.msaa": "Multisampling",
	"dialog.advanced_screenshot.anti_aliasing.ssaa": "Supersampling",
	"dialog.advanced_screenshot.show_gizmos": "Mostra i gadget di modifica",
	"dialog.advanced_screenshot.shading": "Ombreggiatura",
	"settings.auto_keyframe": "Auto Fotogramma",
	"settings.auto_keyframe.desc": "Crea automaticamente un fotogramma con valori predefiniti all'inizio della timeline quando si trasforma l'osso in un secondo momento",
	"settings.modded_entity_integer_size": "Dimensione intera entità modificata",
	"settings.modded_entity_integer_size.desc": "Limita le dimensioni del cubo nel formato entità modificata agli interi. Mentre i float sono tecnicamente supportati in alcune versioni, gli interi sono molto più facili da mappare UV.",
	"category.layers": "Livelli",
	"keybind.paint_secondary_color": "Dipingi con colore secondario",
	"action.selection_tool_operation_mode": "Modalità operazione di selezione",
	"action.selection_tool_operation_mode.create": "Nuova selezione",
	"action.selection_tool_operation_mode.add": "Aggiungi alla selezione",
	"action.selection_tool_operation_mode.subtract": "Sottrai dalla selezione",
	"action.selection_tool_operation_mode.intersect": "Interseca",
	"action.pixel_perfect_drawing": "Disegno pixel perfetto",
	"action.pixel_perfect_drawing.desc": "Disegna linee pixel-art fluide senza doppi pixel sulle curve",
	"action.selection_tool": "Strumento di selezione",
	"action.selection_tool.desc": "Seleziona parti dell'immagine",
	"action.selection_tool.rectangle": "Rettangolo",
	"action.selection_tool.ellipse": "Ellisse",
	"action.selection_tool.lasso": "Selezione con lazo",
	"action.selection_tool.wand": "Bacchetta magica",
	"action.selection_tool.color": "Stesso colore",
	"action.move_layer_tool": "Sposta livello",
	"action.move_layer_tool.desc": "Sposta il livello o la selezione corrente",
	"action.export_modded_animations": "Esporta animazioni di entità modificate",
	"action.export_modded_animations.desc": "Esporta animazioni per un modello di entità modificato Minecraft Java Edition",
	"action.swap_colors": "Scambia colori",
	"action.swap_colors.desc": "Scambia il colore principale con il colore secondario",
	"action.apply_mesh_rotation": "Applica rotazione",
	"action.apply_mesh_rotation.desc": "Reimposta la rotazione dell'elemento della mesh e applicala alla geometria",
	"action.flip_texture_x.desc": "Capovolgi la texture o il livello orizzontalmente",
	"action.flip_texture_y.desc": "Capovolgi la texture o il livello verticalmente",
	"action.rotate_texture_cw.desc": "Ruota la trama o il livello in senso orario",
	"action.rotate_texture_ccw.desc": "Ruota la trama o il livello in senso antiorario",
	"action.crop_texture_to_selection": "Ritaglia trama alla selezione",
	"action.create_empty_layer": "Crea livello vuoto",
	"action.enable_texture_layers": "Attiva Livelli",
	"action.disable_texture_layers": "Disattiva Livelli",
	"action.layer_opacity": "Opacità Livello",
	"action.layer_to_texture_size": "Espandi livello alla dimensione trama",
	"action.layer_to_texture_size.desc": "Espandi livello alla dimensione della trama",
	"action.merge_layer_down": "Unisci Sotto",
	"action.merge_layer_down.desc": "Unisci al livello sottostante",
	"action.advanced_screenshot": "Schermata avanzata...",
	"action.advanced_screenshot.desc": "Fai uno screenshot del modello con opzioni avanzate",
	"action.bake_ik_animation": "Cuoci cinematica inversa",
	"action.bake_ik_animation.desc": "Cuoci le rotazioni applicate dalla cinematica inversa nell'animazione selezionata",
	"action.save_animation_preset": "Salva preset di animazione...",
	"action.save_animation_preset.desc": "Salva i fotogrammi chiave selezionati come preset di animazione",
	"action.animation_onion_skin": "Animazione Onion Skin",
	"action.animation_onion_skin.desc": "Visualizza una vista wireframe di un fotogramma diverso nell'animazione come riferimento",
	"action.apply_animation_preset": "Applica preset di animazione",
	"action.apply_animation_preset.desc": "Seleziona da un elenco di preset di animazione e applicalo all'osso selezionato",
	"menu.brush_presets.pixel_perfect": "Pennello pixel perfetto",
	"panel.layers": "Livelli",
	"uv_editor.copy_paste_tool.to_layer": "A Nuovo Livello",
	"format.image.new": "Crea Nuova Immagine",
	"format.image.info.summary": "L'editor di immagini 2D consente di creare e modificare immagini e pixel art direttamente in Blockbench, senza la necessità di un editor di immagini esterno. Modifica immagini, modifica texture o crea la tua pixel art!",
	"settings.move_with_selection_tool": "Usa lo strumento di selezione per spostare le selezioni",
	"settings.move_with_selection_tool.desc": "Consenti allo strumento di selezione di spostare direttamente le selezioni, senza dover passare allo strumento Sposta livello",
	"settings.final_newline": "Nuova riga finale",
	"settings.final_newline.desc": "Inserisci un carattere di nuova riga alla fine del file esportato files",
	"action.crop_layer_to_selection": "Ritaglia livello in selezione",
	"action.edit_mode_uv_overlay.desc": "Visualizza la mappa UV come sovrapposizione in modalità di modifica",
	"menu.image": "Immagine",
	"menu.texture.discard_changes": "Ignora modifiche",
	"menu.texture.discard_changes.desc": "Ignora tutte le modifiche non salvate e carica l'ultima versione dal file",
	"panel.textures.images": "Immagini",
	"dialog.advanced": "Avanzate",
	"dialog.recommended_option": "consigliato",
	"modifier_actions.snap_to_center": "Aggancia al centro",
	"modifier_actions.snap_to_pixels": "Aggancia ai pixel",
	"message.invalid_format.install_plugin": "Installa plugin '%0'",
	"message.plugin_deprecated.message": "Sei sicuro di voler installare questo plugin deprecato?",
	"message.plugin_deprecated.install_anyway": "Installa comunque",
	"message.image_editor.not_found": "Impossibile trovare l'editor di immagini selezionato. Seleziona un'opzione diversa.",
	"message.knife_tool.confirm": "Premi %0 o fai clic qui per applicare lo strumento coltello",
	"message.knife_tool.skipped_face": "Impossibile tagliare tra facce diverse. Includi i bordi o i vertici tra di loro!",
	"message.optimize_animation.keyframes_removed": "Rimossi %0 keyframe ridondanti",
	"message.optimize_animation.nothing_to_optimize": "Nulla da ottimizzare!",
	"message.duplicate_bone_copy_animation.title": "Copia Animazione",
	"message.duplicate_bone_copy_animation.message": "L'osso duplicato è animato in %0 animazioni. Vuoi copiare i keyframe sul nuovo osso?",
	"message.auto_fix_mesh_edit.title": "Correzione automatica",
	"message.auto_fix_mesh_edit.revert": "Annulla modifica",
	"message.auto_fix_mesh_edit.overlapping_vertices": "Alcuni vertici sono stati spostati nello stesso punto. Come vuoi procedere?",
	"message.auto_fix_mesh_edit.concave_quads": "Una o più facce quad sono ora concave, il che può causare problemi nella mappatura UV e nel rendering. Blockbench può correggerlo automaticamente per te:",
	"message.auto_fix_mesh_edit.merge_vertices": "Unisci vertici",
	"message.auto_fix_mesh_edit.split_quads": "Dividi quadri",
	"message.load_images.add_image": "Aggiungi immagine",
	"dialog.project.modded_entity_entity_class": "Classe entità",
	"dialog.resize_texture.offset": "Compensa",
	"dialog.animated_texture_editor.code_reference": "Riferimento Codice",
	"dialog.animated_texture_editor.code_reference.about": "Questo codice per implementare l'animazione della texture è stato generato come riferimento e non funziona necessariamente senza modifiche. Consulta la documentazione per saperne di più.",
	"dialog.animated_texture_editor.code_reference.docs": "Documentazione",
	"dialog.animated_texture_editor.reframe": "Riformula",
	"dialog.animated_texture_editor.stride": "Dimensioni Fotogramma",
	"dialog.animated_texture_editor.frames": "Numero di fotogrammi",
	"dialog.animated_texture_editor.add_frame": "Aggiungi frame",
	"dialog.animated_texture_editor.resize_frames": "Ridimensiona frame...",
	"dialog.animated_texture_editor.apply": "Applica",
	"dialog.add_primitive.edge_size": "Dimensione bordo",
	"dialog.change_animation_speed.speed": "Velocità",
	"dialog.change_animation_speed.adjust_snapping": "Regola aggancio",
	"dialog.optimize_animation.selection": "Selezione",
	"dialog.optimize_animation.selection.selected_keyframes": "Fotogrammi chiave selezionati",
	"dialog.optimize_animation.selection.selected_animation": "Animazione selezionata",
	"dialog.optimize_animation.selection.all_animations": "Tutte le animazioni",
	"dialog.optimize_animation.thresholds": "Valori soglia",
	"dialog.import_obj.obj": "File OBJ",
	"dialog.import_obj.mtl": "File MTL",
	"dialog.import_obj.scale": "Scala",
	"layout.thumbnail": "CSS miniatura personalizzato",
	"settings.pixel_grid": "Griglia pixel",
	"settings.pixel_grid.desc": "Mostra griglia pixel texture sugli elementi in modalità di modifica",
	"settings.image_editor_grid_size": "Dimensioni griglia editor immagini",
	"settings.image_editor_grid_size.desc": "Dimensioni della griglia grande nell'editor immagini 2D",
	"settings.ground_plane_double_side": "Piano di terra bifacciale",
	"settings.ground_plane_double_side.desc": "Rendi il piano di terra visibile dal basso",
	"settings.optifine_save_default_texture": "OptiFine JEM: Esporta texture selezionata",
	"settings.optifine_save_default_texture.desc": "Esporta la texture selezionata come texture predefinita del modello",
	"action.slider_color_select_threshold": "Soglia di selezione colore",
	"action.slider_color_select_threshold.desc": "Quanto deve essere vicino il colore di un pixel adiacente per essere selezionato tramite selezione colore o bacchetta",
	"action.stretch_tool": "Allunga",
	"action.stretch_tool.desc": "Strumento per selezionare e allungare gli elementi",
	"action.knife_tool": "Strumento coltello",
	"action.knife_tool.desc": "Strumento per tagliare le facce della mesh in pezzi più piccoli",
	"action.duplicate_project": "Duplica progetto",
	"action.duplicate_project.desc": "Crea una copia del progetto aperto",
	"action.transform_space.parent": "Genitore",
	"action.transform_pivot_space": "Spazio di trasformazione pivot",
	"action.solidify_mesh_selection": "Solidifica facce",
	"action.solidify_mesh_selection.desc": "Solidifica le facce selezionate della mesh",
	"action.animated_texture_editor": "Animazione flipbook...",
	"action.animated_texture_editor.desc": "Imposta o modifica l'animazione flipbook della trama selezionata",
	"action.center_individual_pivots": "Centra i singoli perni",
	"action.center_individual_pivots.desc": "Imposta il punto di perno di ogni elemento selezionato sul suo centro",
	"action.uv_cycle": "Ciclo UV",
	"action.uv_cycle.desc": "Scorri l'ordine dei vertici UV senza modificare le posizioni UV",
	"action.uv_cycle_invert": "Ciclo Inverti UV",
	"action.uv_cycle_invert.desc": "Inverti l'ordine dei vertici UV senza modificare le posizioni UV",
	"action.slider_animation_controller_speed": "Velocità di riproduzione del controller",
	"action.slider_animation_controller_speed.desc": "Velocità di riproduzione dei controller di animazione in percentuale",
	"action.optimize_animation": "Ottimizza animazione",
	"action.optimize_animation.desc": "Ottimizza l'animazione corrente e riduci il conteggio dei fotogrammi chiave",
	"action.change_animation_speed": "Cambia velocità animazione...",
	"action.change_animation_speed.desc": "Cambia la velocità dell'animazione selezionata",
	"timeline.select_particle_file": "Seleziona file particella",
	"timeline.select_sound_file": "Seleziona file audio",
	"menu.cube.texture.default": "Predefinito",
	"menu.texture.particle.clear": "Interrompi utilizzo per particelle",
	"menu.texture.use_as_default": "Imposta come predefinito",
	"menu.texture.use_as_default.clear": "Annulla assegnazione come predefinito",
	"menu.toolbar.overflow": "Overflow barra degli strumenti",
	"edit.solidify_mesh_selection.thickness": "Spessore",
	"reference_image.sync_to_timeline": "Sincronizza linea temporale",
	"reference_image.toggle_playback": "Riproduci/Pausa",
	"dialog.add_primitive.shape.beveled_cuboid": "Cuboide smussato",
	"dialog.ignore_all": "Ignora tutto",
	"data.texture_group": "Gruppo Trame",
	"data.animation": "Animazione",
	"generic.on": "Attivo",
	"generic.off": "Disattivo",
	"format.free.info.3d_printing": "Stampa 3D",
	"message.invalid_file.merge_conflict": "Il file contiene conflitti di unione Git non risolti.",
	"dialog.expand_texture_selection.radius": "Importo",
	"dialog.expand_texture_selection.corner": "Forma angolo",
	"dialog.expand_texture_selection.corner.round": "Arrotondato",
	"dialog.expand_texture_selection.corner.square": "Quadrato",
	"dialog.expand_texture_selection.corner.manhattan": "Manhattan",
	"dialog.merge_animation.merge_target": "Unisci in",
	"keybindings.variation_conflict": "Variazione in conflitto con la combinazione di tasti principale",
	"settings.recovery_save_interval": "Intervallo di salvataggio per il ripristino",
	"settings.recovery_save_interval.desc": "Blockbench salva regolarmente il progetto aperto in background per ripristinarlo in caso di crash del computer. Imposta l'intervallo in secondi. Imposta su 0 per disabilitare il salvataggio.",
	"settings.save_view_per_tab": "Salva vista per scheda",
	"settings.save_view_per_tab.desc": "Salva l'angolo di visualizzazione corrente per ogni scheda separatamente",
	"settings.inherit_parent_color": "Eredita colore padre",
	"settings.inherit_parent_color.desc": "Imposta il colore del marcatore di un elemento appena creato sul colore del padre anziché su un colore casuale",
	"keybind.preview_select.multi_select": "Selezione multipla",
	"keybind.preview_select.group_select": "Selezione gruppo",
	"keybind.preview_select.loop_select": "Selezione ciclo",
	"action.fill_mode.selection": "Selezione",
	"action.fill_mode.selected_elements": "Elementi selezionati",
	"action.image_tiled_view": "Vista affiancata",
	"action.image_tiled_view.description": "Attiva la vista affiancata nell'editor 2D",
	"action.image_onion_skin_view": "Editor immagini Onion Skin",
	"action.image_onion_skin_view.description": "Abilita la visualizzazione Onion Skin nell'editor 2D",
	"action.expand_texture_selection": "Espandi selezione texture",
	"action.expand_texture_selection.desc": "Espandi o riduci selezione texture",
	"action.switch_tabs.reverse_order": "Ordine inverso",
	"action.save_project_incremental": "Salva progetto con incremento",
	"action.save_project_incremental.desc": "Salva il modello corrente come file di progetto con un incremento (ad esempio: project_2.bbmodel)",
	"action.copy.multiple": "Copia tutto",
	"action.copy.multiple.desc": "Copia tutti i dati disponibili singolarmente",
	"action.paste.multiple": "Incolla tutto",
	"action.randomize_marker_colors": "Randomizza colori marcatore",
	"action.cube_light_emission": "Emissione di luce",
	"action.cube_light_emission.desc": "Cambia l'emissività dei cubi selezionati, come valore compreso tra 0 e 15",
	"action.view_mode.colored_solid": "Solido con colori marcatore",
	"action.focus_on_selection.rotate_only": "Solo rotazione",
	"action.create_texture_group": "Crea gruppo texture",
	"action.create_texture_group.desc": "Crea un gruppo per le tue texture",
	"action.uv_maximize.all_faces": "Influenza tutte le facce",
	"action.retarget_animators": "Reindirizza animazioni",
	"action.retarget_animators.desc": "Seleziona quale animatore indirizza quale osso o elemento",
	"action.merge_animation": "Unisci animazione",
	"action.merge_animation.desc": "Unisci l'animazione in un'altra animazione",
	"action.add_keyframe.reset_values": "Con valori predefiniti",
	"action.set_timeline_range_start": "Imposta inizio intervallo sequenza temporale",
	"action.set_timeline_range_start.desc": "Imposta il punto di inizio per un intervallo di riproduzione personalizzato nella sequenza temporale dell'animazione",
	"action.set_timeline_range_end": "Imposta fine intervallo sequenza temporale",
	"action.set_timeline_range_end.desc": "Imposta il punto di fine per un intervallo di riproduzione personalizzato nella sequenza temporale dell'animazione",
	"action.disable_timeline_range": "Disattiva intervallo sequenza temporale",
	"action.disable_timeline_range.desc": "Disattiva intervallo di riproduzione personalizzato nella sequenza temporale dell'animazione",
	"menu.texture_group.resolve": "Risolvi",
	"menu.image_tiled_view.mirrored": "Bordi specchiati",
	"menu.image_onion_skin_view.frame": "Fotogrammi",
	"menu.image_onion_skin_view.frame.last_viewed": "Ultimo fotogramma visualizzato",
	"menu.image_onion_skin_view.frame.previous": "Fotogramma precedente",
	"menu.image_onion_skin_view.frame.next": "Fotogramma successivo",
	"menu.image_onion_skin_view.frame.both": "Precedente + Successivo",
	"menu.image_onion_skin_view.display": "Visualizza",
	"menu.image_onion_skin_view.display.pixels": "Pixel più piccoli",
	"menu.image_onion_skin_view.display.transparent": "Trasparente",
	"menu.image_onion_skin_view.above": "Visualizza sopra",
	"menu.animation.reload": "Ricarica",
	"switches.autouv.alt": "Relativo",
	"display.rotation_pivot": "Perno di rotazione",
	"display.scale_pivot": "Scala Perno",
	"display.reference.fox": "Volpe",
	"display.reference.eating": "Mangiare",
	"preview_scene.sky": "Cielo",
	"preview_scene.space": "Spazio",
	"preview_scene.minecraft_ocean": "Oceano",
	"message.import_palette.selection_only": "Solo selezione",
	"dialog.blend_transition_edit.ease_in_out": "Ease-in-out (%0)",
	"dialog.blend_transition_edit.generate": "Genera...",
	"dialog.blend_transition_edit.generate.learn_more": "Ulteriori informazioni e anteprima",
	"dialog.blend_transition_edit.generate.curve": "Tipo di Easing",
	"dialog.blend_transition_edit.generate.steps": "Fotogrammi",
	"settings.fps_limit": "Limite FPS",
	"settings.fps_limit.desc": "Limita il numero di fotogrammi al secondo renderizzati da Blockbench. Il frame rate effettivo è limitato a ciò che il tuo dispositivo può visualizzare.",
	"settings.outliner_reveal_on_select": "Mostra elementi alla selezione",
	"settings.outliner_reveal_on_select.desc": "Mostra gli elementi nell'outliner quando selezionati",
	"settings.java_export_pivots": "Esporta pivot nei modelli Java block/item",
	"settings.java_export_pivots.desc": "Salva i punti pivot nei modelli Java block/item sui cubi senza rotazione",
	"animation_controllers.state.blend_transition_curve": "Curva di transizione blend",
	"menu.slider.reset_vector": "Reimposta vettore",
	"dialog.blend_transition_edit.extended": "Grafico esteso",
	"message.screenshot_too_large.title": "Problema di risoluzione dello screenshot",
	"message.screenshot_too_large.message": "Impossibile eseguire correttamente il rendering dello screenshot. Riprova con una risoluzione inferiore o senza supersampling.",
	"message.rename_elements.numbering": "Puoi usare caratteri speciali per generare numeri sequenziali: % per ottenere l'indice dell'elemento all'interno del suo gruppo, $ per ottenere l'indice all'interno della selezione.",
	"generic.edit_externally": "Modifica esternamente",
	"message.settings_require_restart.title": "Riavvio richiesto",
	"message.settings_require_restart.message": "Alcune impostazioni verranno applicate solo dopo aver riavviato il programma.",
	"message.settings_require_restart.restart_now": "Riavvia ora",
	"message.settings_require_restart.restart_later": "Riavvia più tardi",
	"message.classroom_mode.install_plugin": "Impossibile installare plugin in modalità classe",
	"dialog.collection.export_path": "Percorso di esportazione",
	"dialog.collection.select_all": "Seleziona tutto",
	"dialog.collection.select_none": "Nessuno",
	"dialog.collection.add_with_filter": "Aggiungi con filtro",
	"dialog.collection.remove": "Rimuovi",
	"dialog.material_config.title": "Configurazione materiale",
	"dialog.material_config.color_value": "Valore colore",
	"dialog.material_config.mer": "Rugosità emissiva del metallo",
	"dialog.material_config.mer_value": "Valore MER",
	"dialog.material_config.depth_type": "Tipo profondità",
	"dialog.create_texture.disable_mirror_uv": "Disattiva specchiatura UV",
	"dialog.create_texture.disable_mirror_uv.desc": "Disattiva l'opzione Specchio UV in Modellazione specchio per preservare UV separati per ogni lato del modello",
	"dialog.create_gif.turn.sync_to_anim_length": "Sincronizzazione con l'animazione lunghezza",
	"settings.category.controls": "Controlli",
	"settings.classroom_mode": "Modalità classe",
	"settings.classroom_mode.desc": "Limita funzionalità come l'installazione di plugin e rimuove i link ai social media",
	"settings.antialiasing_bleed_fix": "Corregge il bleeding dell'anti-aliasing",
	"settings.antialiasing_bleed_fix.desc": "Corregge il bleeding delle texture quando si usa l'anti-aliasing",
	"settings.tone_mapping": "Tone Mapping",
	"settings.tone_mapping.desc": "Metodo di approssimazione per visualizzare un'ampia gamma dinamica su uno schermo standard per il rendering PBR.",
	"settings.audio_scrubbing": "Scrubbing audio della linea temporale",
	"settings.audio_scrubbing.desc": "Riproduci brevi anteprime dell'audio durante lo scrubbing nella linea temporale",
	"settings.viewport_rotate_speed": "Velocità di rotazione della finestra",
	"settings.viewport_rotate_speed.desc": "Sensibilità di input durante la rotazione nella finestra",
	"settings.viewport_zoom_speed": "Velocità di zoom della finestra",
	"settings.viewport_zoom_speed.desc": "Sensibilità di input durante lo zoom nella finestra",
	"settings.editor_2d_zoom_speed": "Velocità di zoom dell'editor 2D",
	"settings.editor_2d_zoom_speed.desc": "Sensibilità di input durante lo zoom nell'editor di vernice UV e 2D",
	"category.select": "Seleziona",
	"action.vertex_snap_mode.rotate": "Ruota",
	"action.export_image": "Esporta Immagine",
	"action.export_image.desc": "Esporta la tua trama come file immagine",
	"action.apply_mirror_modeling": "Applica modellazione speculare",
	"action.apply_mirror_modeling.desc": "Applica modellazione speculare alla selezione. Tutti gli elementi selezionati verranno copiati e capovolti lungo l'asse X.",
	"action.create_collection": "Crea raccolta",
	"action.create_collection.desc": "Crea una raccolta dalla selezione outliner",
	"action.set_collection_content_to_selection": "Imposta il contenuto della raccolta su Selezionato",
	"action.set_collection_content_to_selection.desc": "Imposta i gruppi e gli elementi selezionati come contenuto della raccolta",
	"action.add_to_collection": "Aggiungi selezionato alla raccolta",
	"action.add_to_collection.desc": "Aggiungi i gruppi e gli elementi selezionati alla raccolta",
	"action.view_mode.material": "Anteprima materiale",
	"action.create_material": "Crea materiale",
	"action.create_material.desc": "Crea un nuovo materiale PBR dalla texture selezionata",
	"action.generate_pbr_map": "Genera mappa PBR...",
	"action.generate_pbr_map.desc": "Genera una mappa PBR (mappa altezza o metalness, emissività, ruvidità) da una texture esistente",
	"menu.tools.main_tools": "Strumenti",
	"menu.view.panels": "Pannelli",
	"menu.texture.pbr_channel": "Canale PBR",
	"menu.texture.pbr_channel.color": "Colore",
	"menu.texture.pbr_channel.normal": "Normale",
	"menu.texture.pbr_channel.height": "Altezza",
	"menu.texture.pbr_channel.mer": "MER (Metalness-Emissive-Rugosità)",
	"menu.texture.pbr_channel.mer_subsurface": "Sottosuolo MER",
	"menu.collection.export_project": "Esporta Progetto",
	"menu.collection.export_as": "Esporta come \"%0\"",
	"menu.panel.enable": "Attiva",
	"menu.panel.move_to": "Sposta in",
	"menu.panel.move_to.left_bar": "Barra laterale sinistra",
	"menu.panel.move_to.right_bar": "Barra laterale destra",
	"menu.panel.move_to.top": "Alto",
	"menu.panel.move_to.bottom": "Basso",
	"menu.panel.move_to.float": "Mobile",
	"menu.panel.move_to.hidden": "Nascondi",
	"menu.panel.fold": "Comprimi",
	"menu.mirror_painting.texture_center": "Origine",
	"menu.mirror_modeling.mirror_uv": "Specchio UV",
	"menu.animation_onion_skin.frames": "Fotogrammi",
	"menu.animation_onion_skin.select": "Seleziona",
	"menu.animation_onion_skin.previous": "Precedente",
	"menu.animation_onion_skin.next": "Avanti",
	"menu.animation_onion_skin.previous_next": "Precedente + Successivo",
	"menu.animation_onion_skin.count": "Conteggio",
	"menu.animation_onion_skin.interval": "Intervallo",
	"menu.animation_onion_skin_selective": "Onion Skin selettiva",
	"menu.animation_onion_skin_selective.desc": "Visualizza solo Onion Skin per la parte selezionata del modello",
	"edit.loop_cut.unit": "Unità",
	"edit.loop_cut.unit.size_units": "Unità Misura",
	"edit.loop_cut.unit.percent": "Percentuale",
	"edit.extrude_mesh_selection.direction": "Direzione",
	"edit.extrude_mesh_selection.direction.outwards": "Verso l'esterno",
	"edit.extrude_mesh_selection.direction.average": "Media",
	"edit.extrude_mesh_selection.even_extend": "Estensione uniforme",
	"edit.vertex_snap.align": "Allinea",
	"edit.vertex_snap.align.longest": "Asse più lungo",
	"edit.vertex_snap.align.direction": "Direzione dal pivot",
	"edit.vertex_snap.align.align_axis": "Asse %0",
	"edit.vertex_snap.ignore_axis": "Ignora asse",
	"codec.common.format": "Formato",
	"codec.image.quality": "Qualità",
	"panel.collections": "Raccolte",
	"modifier_actions.always": "Sempre attivato",
	"modifier_actions.unless": "A meno che %0",
	"settings.undo_selections": "Annulla selezione",
	"settings.undo_selections.desc": "Traccia le modifiche alla selezione come un passaggio nella cronologia degli annullamenti",
	"action.focus_on_selection.zoom": "Adatta Zoom",
	"display.reference.tooting": "Suono Clacson",
	"settings.selection_tolerance": "Tolleranza Selezione",
	"settings.selection_tolerance.desc": "Dimensione dell'area su cui è possibile fare clic per selezionare un bordo o un vertice",
	"action.delete.keep_vertices": "Mantieni bordi/vertici",
	"menu.mesh": "Mesh",
	"dialog.material_config.subsurface": "Dispersione Sottosuolo",
	"dialog.material_config.subsurface_enabled.desc": "Utilizza il canale alfa della mappa MER per la diffusione del sottosuolo",
	"settings.pick_combined_color": "Scegli Colore Combinato",
	"settings.pick_combined_color.desc": "Seleziona il colore combinato di tutti i livelli nel rispettivo pixel, invece del colore sul livello attivo",
	"action.split_rgb_into_layers": "Dividi Canali RGB in Livelli",
	"action.split_rgb_into_layers.desc": "Dividi la trama in livelli additivi, uno per ogni canale RGB",
	"dialog.project.java_block_version": "Format Version",
	"data.spline_mesh": "Spline",
	"data.billboard": "Billboard",
	"data.armature": "Armature",
	"data.armature_bone": "Armature Bone",
	"generic.reload": "Reload",
	"modifier_actions.subtract": "Subtract",
	"modifier_actions.reduced_intensity": "Fine-Tune",
	"modifier_actions.select_bone": "Select Bone",
	"modifier_actions.spline_select_multiple_points": "Select multiple Points or Handles",
	"modifier_actions.move_panel_without_docking": "Move without docking",
	"message.save_all_textures.message": "Do you want to save each of the following textures?",
	"message.save_all_textures.skip": "Skip",
	"dialog.add_spline.shape": "Shape",
	"dialog.add_spline.shape.segment": "Segment",
	"dialog.add_spline.shape.square": "Rectangle",
	"dialog.add_spline.shape.circle": "Circle",
	"dialog.add_spline.diameter": "Diameter",
	"dialog.add_spline.sides_tubular": "Tube Segments",
	"dialog.add_spline.sides_radial": "Ring Segments",
	"dialog.add_spline.radius": "Tube Radius",
	"dialog.add_spline.length": "Length",
	"dialog.add_spline.width": "Width",
	"dialog.plugins.revoke_permissions": "Revoke Permissions",
	"dialog.expression_editor.pretty_print": "Pretty Print",
	"dialog.expression_editor.minify": "Minify",
	"dialog.expression_editor.find_replace": "Find/Replace",
	"dialog.create_gif.show_gizmos": "Record Gizmos & Grid",
	"dialog.preview_options.title": "Preview Options",
	"dialog.preview_options.background": "Background",
	"dialog.preview_options.background.checkerboard": "Checkerboard",
	"dialog.preview_options.background.solid": "Solid",
	"dialog.preview_options.background.custom_color": "Custom Color",
	"dialog.preview_options.show_gizmos": "Show Gizmos",
	"dialog.skin.texture_source": "Texture Source",
	"dialog.skin.texture_source.template": "Generate Template",
	"dialog.skin.texture_source.load_texture": "Load from Minecraft",
	"dialog.skin.texture_file": "Texture File",
	"dialog.convert_skin.adjust_texture": "Adjust Texture",
	"dialog.settings.clear_profile_value": "Clear profile value",
	"layout.section.customize": "Customize",
	"layout.theme.configure": "Configure",
	"layout.color.elevated": "Elevated",
	"layout.color.elevated.desc": "Elevated UI elements, usually separated by drop shadow",
	"layout.file.watch_changes": "Watch Changes and Reload",
	"settings.autocomplete_code": "Autocomplete Code",
	"settings.autocomplete_code.desc": "Display autocomplete suggestions in code editors",
	"settings.detect_flipbook_textures": "Detect Flipbook Textures",
	"settings.detect_flipbook_textures.desc": "Automatically detect flipbook animated textures and preview them as animation",
	"settings.double_click_select_reference": "Select Reference Image on Double Click",
	"settings.double_click_select_reference.desc": "Double click the viewport to select a reference image",
	"settings.default_keyframe_interpolation": "Default Keyframe Interpolation",
	"settings.default_keyframe_interpolation.desc": "Select the default keyframe interpolation mode",
	"settings.color_picker_style": "Color Picker Style",
	"settings.color_picker_style.desc": "Select the style of the paint mode color picker",
	"settings.export_asset_paths": "Export Asset Paths",
	"settings.export_asset_paths.desc": "Select how paths to assets such as textures or animations get saved in .bbmodel files",
	"settings.export_asset_paths.relative": "Relative Paths",
	"settings.export_asset_paths.absolute": "Full Paths",
	"settings.export_asset_paths.both": "Relative & Full Paths (Texture only)",
	"settings.export_asset_paths.none": "No Export",
	"action.slider_spline_resolution": "Spline Resolution %0",
	"action.slider_spline_resolution.desc": "Change spline resolution on the %0 axis (%1)",
	"action.slider_spline_resolution.u.desc_precision": "Ring Segments",
	"action.slider_spline_resolution.v.desc_precision": "Tube Segments",
	"action.slider_spline_radius": "Spline Radius",
	"action.slider_spline_radius.desc": "Change spline Radius",
	"action.slider_spline_handle_tilt": "Handle Tilt",
	"action.slider_spline_handle_tilt.desc": "Change spline handle Tilt",
	"action.slider_spline_handle_size": "Handle Size",
	"action.slider_spline_handle_size.desc": "Change spline handle Size",
	"action.blend_mode.lighten": "Lighten",
	"action.blend_mode.darken": "Darken",
	"action.weight_brush": "Weight Brush",
	"action.weight_brush.desc": "Paint vertex weights on meshes for armature deformations",
	"action.convert_minecraft_skin_variant": "Convert Slim/Wide Skin",
	"action.convert_minecraft_skin_variant.desc": "Switch the skin model between the classic wide (steve) model and the slim (alex) model. Optionally auto-adjust the texture to fit the model",
	"action.custom_skin_poses": "Custom Skin Poses",
	"action.custom_skin_poses.desc": "Load a custom skin pose preset",
	"action.custom_skin_poses.update": "Update Pose",
	"action.custom_skin_poses.update.desc": "Overwrite the saved pose with the current pose of the model",
	"action.add_custom_skin_pose": "Add Custom Skin Pose",
	"action.add_custom_skin_pose.desc": "Save the current pose of the model as a pose preset",
	"action.export_stl": "Export STL",
	"action.export_stl.desc": "Export a STL model for 3D printing",
	"action.add_element": "Add Element",
	"action.add_element.desc": "Add a new element from the list of element types",
	"action.add_spline": "Add Spline",
	"action.add_spline.desc": "Adds a new spline",
	"action.add_billboard": "Add Billboard",
	"action.add_billboard.desc": "Adds a new billboard, a flat element that always faces towards the camera",
	"action.add_armature": "Add Armature",
	"action.add_armature.desc": "Adds an armature that allows deforming a mesh via animation",
	"action.add_armature_bone": "Add Armature Bone",
	"action.add_armature_bone.desc": "Adds a bone to the armature",
	"action.search_textures": "Search Textures",
	"action.search_textures.desc": "Search for textures by name",
	"action.search_animations": "Search Animations",
	"action.search_animations.desc": "Search for animations by name",
	"action.spline_selection_mode": "Spline Selection Mode",
	"action.spline_selection_mode.object": "Object",
	"action.spline_selection_mode.handles": "Handles",
	"action.spline_render_mode": "Geometry",
	"action.spline_render_mode.mesh": "Mesh",
	"action.spline_render_mode.path": "Path",
	"action.spline_render_mode.desc": "Which geometry this spline should render",
	"action.spline_uv_mode": "UV Style",
	"action.spline_uv_mode.length_accurate": "Length Accurate",
	"action.spline_uv_mode.uniform": "Uniform",
	"action.spline_uv_mode.per_segment": "Per Segment",
	"action.spline_uv_mode.desc": "How the spline's tube mesh should lay its UVs",
	"action.spline_ring_segments": "Ring Segments",
	"action.spline_ring_segments.desc": "How many subdivisions this Spline has per Tube Ring",
	"action.spline_tube_segments": "Tube Segments",
	"action.spline_tube_segments.desc": "How many subdivisions this Spline has along its path",
	"action.spline_tube_radius": "Tube Radius",
	"action.spline_tube_radius.desc": "Set the Spline's Tube Radius",
	"action.spline_display_space": "Display Space",
	"action.spline_display_space.desc": "Display spline space indicators on its path",
	"action.spline_handle_mode": "Spline Handle Mode",
	"action.spline_handle_mode.desc": "Which mode to use for transforming spline handles",
	"action.spline_handle_mode.aligned": "Aligned",
	"action.spline_handle_mode.free": "Free",
	"action.spline_handle_mode.mirrored": "Mirrored",
	"action.slider_weight_brush_size": "Weight Brush Size",
	"action.weight_brush_xray": "Weight Brush XRay Mode",
	"action.weight_brush_xray.desc": "When enabled, the weight brush will affect all vertices instead of just the ones that are visible on the surface",
	"action.apply_spline_rotation": "Apply Rotation",
	"action.apply_spline_rotation.desc": "Reset the element rotation of the spline, and apply it to the geometry instead",
	"action.extrude_spline_selection": "Extrude Spline",
	"action.extrude_spline_selection.desc": "Extrude the selected handle on all splines",
	"action.split_spline": "Split Spline",
	"action.split_spline.desc": "Splits the spline into two splines at the selected handle",
	"action.divide_spline_curve": "Divide Spline Segment",
	"action.divide_spline_curve.desc": "Splits the spline segment into two new segments with a new handle at their intersection",
	"action.set_vertex_weights": "Set Vertex Weights",
	"action.set_vertex_weights.desc": "Set the vertex weights of the selected vertices to a specific value on a certain armature bone",
	"action.calculate_vertex_weights": "Calculate Vertex Weights",
	"action.calculate_vertex_weights.desc": "Automatically assign vertex weights weights based on the position of the bones",
	"action.shelf_alignment": "Shelf Alignment",
	"action.shelf_alignment.desc": "Select the vertical alignment of items on the shelf",
	"action.shelf_alignment.top": "Top Alignment",
	"action.shelf_alignment.bottom": "Bottom Alignment",
	"action.view_mode.vertex_weight": "Vertex Weight",
	"action.view_mode.weighted_bone_colors": "Vertex Bone Colors",
	"action.create_animation_group": "Create Animation Group",
	"action.create_animation_group.desc": "Create a group of animations",
	"action.move_graph_keyframes_up": "Move Keyframe Graph Up",
	"action.move_graph_keyframes_down": "Move Keyframe Graph Down",
	"menu.skin": "Skin",
	"menu.text_edit.expression_editor": "Expression Editor",
	"menu.color_picker.picker_type.normal": "Normal Map",
	"menu.texture.flipbook_animation": "Flipbook Animation",
	"menu.panel.attach_to": "Attach To",
	"menu.animation.playing": "Playing",
	"menu.animation_file.save_as": "Save As",
	"menu.animator.quaternion_interpolation": "Quaternion Interpolation",
	"edit.extrude_spline_selection.extend": "Extend",
	"edit.divide_spline_curve.position": "Position",
	"group.bedrock_binding": "Binding",
	"group.cem_attach": "CEM Attach",
	"group.cem_model": "CEM Model",
	"group.cem_scale": "CEM Scale",
	"cube.rescale": "Rotation Rescale",
	"cube.rescale.desc": "Rescale cube to compensate for the rotation angle",
	"mesh.shading": "Shading",
	"mesh.shading.flat": "Flat",
	"mesh.shading.smooth": "Smooth",
	"spline_mesh.cyclic": "Cyclic",
	"spline_mesh.cyclic.desc": "Whether the selected spline should form a loop (Cycle)",
	"billboard.offset": "Offset",
	"billboard.facing_mode": "Facing Mode",
	"billboard.facing_mode.lookat": "Look At",
	"billboard.facing_mode.lookat_y": "Look At Y",
	"billboard.facing_mode.rotate": "Rotate",
	"billboard.facing_mode.rotate_y": "Rotate Y",
	"armature_bone.connected": "Connected",
	"reference_image.blueprint": "Locked Blueprint",
	"codec.image.alpha_channel": "Alpha Channel",
	"codec.image.animation_fps": "Animation FPS",
	"panel.palette": "Palette",
	"panel.keyframe.change_effect_file": "Change Effect File",
	"panel.transform": "Transform",
	"panel.element.spline_dimensions": "Spline Dimensions",
	"display.slot.on_shelf": "Shelf",
	"display.reference.shelf": "Shelf (All Slots)",
	"display.reference.shelf_left": "Shelf (Left Slot)",
	"display.reference.shelf_center": "Shelf (Center Slot)",
	"display.reference.shelf_right": "Shelf (Right Slot)",
	"message.newer_project_format_version.title": "Outdated client",
	"message.newer_project_format_version.message": "This file was saved in a newer version of Blockbench. Update to Blockbench %0 or newer to be able to open it correctly",
	"message.load_images.add_layer": "Add as Layer",
	"message.load_images.category.add_to_project": "Add to project",
	"message.load_images.category.new_project": "New project",
	"message.load_palette.title": "Load Palette",
	"message.load_palette.message": "Are you sure you want to load this palette? This will replace your current color palette.",
	"dialog.set_vertex_weights.weight": "Weight",
	"dialog.set_vertex_weights.overwrite": "Overwrite other bones",
	"action.element_render_order.short": "Render Order",
	"action.element_render_order.desc": "Render order of elements. This can help fix elements that are hidden behind other elements with transparent textures. Leave it on Auto for opaque elements.",
	"spline.shading.flat": "Flat",
	"spline.shading.smooth": "Smooth",
	"spline.shading": "Shading",
	"spline.shading.desc": "How this spline's tube should be shaded",
	"action.slider_weight_brush_limit": "Weight Brush Limit",
	"action.slider_weight_brush_limit.desc": "Set an upper limit for how much weight the weight brush can assign to a vertex",
	"action.weight_brush_blend_mode": "Weight Brush Blend Mode",
	"action.weight_brush_blend_mode.set": "Set",
	"action.weight_brush_blend_mode.add": "Add",
	"action.apply_texture_to_elements": "Apply Texture to Elements",
	"action.apply_texture_to_elements.desc": "Apply the selected texture to the selected elements",
	"menu.panel.reset_size": "Reset Size",
	"action.import_layer": "Import Layer",
	"action.import_layer.desc": "Import image files as layers",
	"menu.collection.open_file": "Open File",
	"layout.version": "Version",
	"settings.status_bar_transform_sliders": "Transform Sliders in Status Bar",
	"settings.status_bar_transform_sliders.desc": "Display the transform sliders toolbar of the selected tool in the status bar instead of using the Transform panel",
	"settings.default_bedrock_format": "Default Bedrock Format",
	"settings.default_bedrock_format.desc": "Select the default format to load Minecraft Bedrock models in, when no specific format can be detected from context.",
	"settings.limit_brush_opacity_per_stroke": "Limit Brush Opacity per Stroke",
	"settings.limit_brush_opacity_per_stroke.desc": "Limit the opacity that a brush can apply to the value of the opacity slider during each brush stroke. With a smooth brush this behavior can potentially lead to slight unwanted noise.",
	"action.merge_splines": "Merge Splines",
	"action.merge_splines.desc": "Merge multiple splines into one",
	"settings.default_java_block_version": "Default Java Block/Item Version",
	"settings.default_java_block_version.desc": "Default format version when creating new Java block/item models or opening files without format version",
	"data.bounding_box": "Bounding Box",
	"keys.option": "Option",
	"keys.slide_lmb_horizontal": "Left-click slide horizontal",
	"keys.slide_lmb_vertical": "Left-click slide vertical",
	"keys.slide_rmb_horizontal": "Right-click slide horizontal",
	"keys.slide_rmb_vertical": "Right-click slide vertical",
	"message.recover_backup.unknown_project": "Unknown project",
	"message.recover_backup.discard_others": "Discard all others",
	"message.unsupported_file_extension.title": "File format not supported",
	"message.unsupported_file_extension.message": "Cannot open file %0, the format is not supported. You might need a plugin for this file type.",
	"message.unsupported_file_extension.open_in_default_program": "Open in default program",
	"dialog.project.uv_size": "UV Size",
	"dialog.collection.offset": "Offset",
	"dialog.texture.fps": "FPS",
	"dialog.texture.fps.desc": "Frames per second of the texture flipbook animation",
	"dialog.edit_uv_size.title": "Edit UV Size",
	"dialog.edit_uv_size.target": "Target",
	"dialog.edit_uv_size.adjust": "Adjust",
	"dialog.edit_uv_size.adjust.adjust_uv": "Counter UV",
	"dialog.edit_uv_size.adjust.adjust_scale": "Counter UV & Scale",
	"dialog.edit_uv_size.adjust.keep": "Keep UV",
	"dialog.edit_uv_size.target_size": "Target UV Size",
	"dialog.edit_uv_size.preset.original": "Original",
	"dialog.edit_uv_size.preset.match_texture": "Match Texture",
	"dialog.edit_uv_size.result": "Result",
	"dialog.edit_uv_size.result.textures": "Textures",
	"dialog.adjust_brightness_contrast.brightness": "Brightness",
	"dialog.adjust_brightness_contrast.contrast": "Contrast",
	"dialog.adjust_saturation_hue.saturation": "Saturation",
	"dialog.adjust_saturation_hue.hue": "Hue",
	"dialog.adjust_opacity.mode": "Mode",
	"dialog.adjust_opacity.mode.multiply": "Multiply",
	"dialog.adjust_opacity.mode.set": "Set",
	"dialog.bedrock_bounding_box.type": "Type",
	"dialog.bedrock_bounding_box.type.collision_box": "Collision",
	"dialog.bedrock_bounding_box.type.selection_box": "Selection Box",
	"dialog.bedrock_bounding_box.type.hitbox": "Hitbox",
	"dialog.bedrock_bounding_box.hitbox_note": "Please note that entity hitboxes only work up to a certain size and may not adapt to the rotation of the entity in-game.",
	"dialog.bedrock_bounding_box.collision_note": "Please note that entity collision boxes only support one centered shape with a square top profile.",
	"dialog.bedrock_bounding_box.no_bounding_boxes": "No bounding boxes exist in this project",
	"dialog.install_plugins_from_list.ids": "Plugin IDs",
	"dialog.install_plugins_from_list.info": "Install several plugins from a list of IDs. Before installing, please ensure that you actually need all plugins. Keeping inactive plugins can increase the risk of bugs and incompatibilities with future updates.",
	"dialog.copy_installed_plugins.details": "Include Details",
	"dialog.flip_animation.phase_offset": "Phase Offset",
	"dialog.flip_animation.phase_offset.off": "Off",
	"dialog.flip_animation.phase_offset.custom": "Custom",
	"dialog.flip_animation.clear_opposite": "Overwrite opposite",
	"settings.flipbook_textures_in_animation": "Play Flipbook Textures in Animation",
	"settings.flipbook_textures_in_animation.desc": "Preview animations on flipbook textures in sync with the animation timeline",
	"settings.display_uv": "Display UV Faces",
	"settings.display_uv.desc": "Select which UV faces are displayed in the UV editor",
	"settings.display_uv.selected_faces": "Only selected faces",
	"settings.display_uv.selected_elements": "All faces on selected elements",
	"settings.display_uv.all_elements": "All faces on all elements",
	"settings.local_position_values": "Local Position Values",
	"settings.local_position_values.desc": "Display all position values in the Transform panel in local space",
	"settings.transform_cube_from_center": "Transform Cubes from Center",
	"settings.transform_cube_from_center.desc": "Edit the cube position values from the center instead of the corner",
	"settings.color_picker_tool_switch": "Color Picker Tool Switch",
	"settings.color_picker_tool_switch.desc": "When picking a transparent pixel, switch to the eraser. When the eraser was previously selected and a color is picked, switch to the brush",
	"keybind.preview_scroll_zoom": "Zoom View",
	"keybind.uv_editor_scroll_zoom": "Zoom UV/2D Editor",
	"action.blend_mode.alpha_mask": "Alpha Mask",
	"action.swap_tools.hold": "Hold to swap (Color Picker)",
	"action.import_bedrock_voxel_shape": "Import Bedrock Voxel Shape",
	"action.import_bedrock_voxel_shape.desc": "Add a voxel shape from a json file to the current project",
	"action.export_bedrock_voxel_shape": "Export Bedrock Voxel Shape",
	"action.export_bedrock_voxel_shape.desc": "Export the bounding boxes in the project as a bedrock voxel shape file",
	"action.plugins_window_menu": "Menu",
	"action.copy_installed_plugins": "Copy Installed Plugins",
	"action.copy_installed_plugins.desc": "Generate and copy a list of the currently installed plugins",
	"action.install_plugins_from_list": "Install Plugins from List",
	"action.install_plugins_from_list.desc": "Install plugins from a list of plugin IDs",
	"action.add_bounding_box": "Add Bounding Box",
	"action.add_bounding_box.desc": "Adds a new bounding box",
	"action.split_alpha_into_layer": "Split Alpha Channel into Layer",
	"action.split_alpha_into_layer.desc": "Split the alpha channel of the texture into an alpha mask layer",
	"action.generate_bedrock_block_box": "Copy Collision/Selection Component",
	"action.generate_bedrock_block_box.desc": "Generate a collision or selection box component for Minecraft Bedrock Edition blocks",
	"action.generate_bedrock_entity_box": "Copy Collision/Hitbox Component",
	"action.generate_bedrock_entity_box.desc": "Generate a collision or custom hit test component for Minecraft Bedrock Edition entities",
	"action.refresh_texture": "Refresh Texture",
	"action.refresh_texture.desc": "Reload the texture from file",
	"action.move_uv_to_cursor": "Move UV to Cursor",
	"action.move_uv_to_cursor.desc": "Move the selected UV faces to the mouse cursor position",
	"action.edit_mode_uv_overlay": "Display All Elements",
	"action.round_keyframe_values": "Round Keyframe Values",
	"action.round_keyframe_values.desc": "Round all values of the selected keyframes",
	"action.keyframe_column_create.all_channels": "All Channels",
	"action.keyframe_column_create.all_channels.desc": "Initialize all channels with keyframes even if they had no keyframes previously",
	"action.add_all_to_timeline": "Add All to Timeline",
	"action.mirror_animating": "Mirror Animating",
	"action.mirror_animating.desc": "Mirror animation edits to the opposite side",
	"action.copy_animation_pose": "Copy Animation Pose",
	"action.copy_animation_pose.desc": "Copy all keyframes to replicate the current animation pose",
	"menu.texture.file_format": "File Format",
	"menu.texture.wrap_mode": "Wrap Mode",
	"menu.texture.wrap_mode.limited": "Restricted",
	"menu.texture.wrap_mode.repeat": "Repeat",
	"menu.texture.wrap_mode.clamp": "Clamp Edge",
	"edit.reparent_selection.adjust_position": "Preserve World Transform",
	"texture_mesh.texture_name": "Texture Name",
	"display.slot.embedded": "Embedded",
	"display.animate_preview": "Preview Animation",
	"display.reference.flower_pot": "Flower Pot"
}